;(function(window, document, undefined) {
  'use strict';
var Deferred = (function(){
  Promise.settle = function(promisesArr){
    var reflectedArr = promisesArr.map(function(promise){
      return promise.then(function(successResult){
        return {
          result: successResult,
          status: 'resolved'
        };
      },function(errorResult){
        return {
          result: errorResult,
          status: 'rejected'
        };
      });
    });
    return Promise.all(reflectedArr);
  };
  
  function Deferred(){
    var def = this;
    /**
     * @instance
     * @memberof Flybits.Deferred
     * @member {external:Promise} promise Instance of an ES6 Promise to be fulfilled.
     */
    this.promise = new Promise(function(resolve,reject){
      /**
       * @instance
       * @memberof Flybits.Deferred
       * @member {function} resolve Callback to be invoked when the asychronous task that initiated the promise is successfully completed.
       */
      def.resolve = resolve;
      /**
       * @instance
       * @memberof Flybits.Deferred
       * @member {function} reject Callback to be invoked when the asychronous task that initiated the promise has failed to complete successfully.
       */
      def.reject = reject;
    });

    this.then = this.promise.then.bind(this.promise);
    this.catch = this.promise.catch.bind(this.promise);
  }

  return Deferred;
})();

var Validation = (function(){
  function Validation(){
    this.state = true;
    this.errors = [];

    this.stacktrace = "";

    this.setStackTrace();
  }

  Validation.prototype = {
    addError: function(header,message,detailsObj){
      this.state = false;
      var retObj = {
        header: header,
        message: message
      };
      if(detailsObj){
        retObj.context = detailsObj.context;
        retObj.code = detailsObj.code;
        retObj.serverCode = detailsObj.serverCode;
      }
      this.errors.push(retObj);

      return this;
    },
    firstError: function(){
      if(this.errors.length > 0){
        return this.errors[0];
      }
      return null;
    },
    setStackTrace: function(){
      var flyError = new Error();
      flyError.name = "FlybitsError";
      this.stacktrace = flyError.stack;
      if(this.stacktrace){
        this.stacktrace = this.stacktrace.split('\n').filter(function(str){
          return str.indexOf('Validation') < 0;
        }).join('\n');
      }
      return this;
    }
  };

  Validation.prototype.type = Validation.type = {};
  Validation.prototype.type.MALFORMED = Validation.type.MALFORMED = 1000;
  Validation.prototype.type.INVALIDARG = Validation.type.INVALIDARG = 1001;
  Validation.prototype.type.MISSINGARG = Validation.type.MISSINGARG = 1002;
  Validation.prototype.type.NOTFOUND = Validation.type.NOTFOUND = 1003;
  Validation.prototype.type.CONNECTIONERROR = Validation.type.CONNECTIONERROR = 1004;
  Validation.prototype.type.UNAUTHENTICATED = Validation.type.UNAUTHENTICATED = 1005;
  Validation.prototype.type.RETRIEVALERROR = Validation.type.RETRIEVALERROR = 1006;
  Validation.prototype.type.NOTSUPPORTED = Validation.type.NOTSUPPORTED = 1007;
  Validation.prototype.type.UNEXPECTED = Validation.type.UNEXPECTED = 1008;

  return Validation;
})();

var AppWindow = (function(){
  jsPanel.autopositionSpacing = 10;

  function AppWindow(opts){
    this.tmpID = App.util.Obj.guid();
    this.name = opts? opts.name || '':'';
    this.width = opts? opts.width || 325:325;
    this.height = opts? opts.height || 627:627;
    this.container = opts? opts.container || document.body: document.body;
    this.url = opts? opts.url || null:null;
    this.panel = null;
    this.onclosed = opts?opts.onclosed:null;
  };

  AppWindow.prototype = {
    create: function(){
      var appWin = this;
      if(this.panel){
        return this.panel;
      }

      this.panel = jsPanel.create({
        position: {
          my: 'left-top',
          at: 'left-top',
          autoposition: 'right',
          offsetX: 10,
          offsetY: 10
        },
        panelSize: {
          width: this.width,
          height: this.height
        },  
        headerTitle: this.name,
        container: this.container,
        onclosed: function(){
          if(appWin.onclosed){
            appWin.onclosed();
          }
        }
      });

      if(this.url){
        this.setURL(this.url);
      }

      return this;
    },
    setURL: function(url){
      var appWin = this;
      this.url = url;
      this.panel.content.innerHTML = '';
      if(!url){
        return this;
      }

      var overlay = document.createElement('div');
      overlay.setAttribute('class','frame-overlay');
      overlay.innerHTML = '<div class="lds-ripple"><div></div><div></div></div>' + 
      '<img src="images/logoIcon.png" class="logo">';
      this.panel.content.appendChild(overlay);


      var frame = document.createElement('iframe');
      frame.setAttribute('src', url);
      frame.setAttribute('sandbox','allow-forms allow-modals allow-orientation-lock allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-scripts allow-top-navigation allow-top-navigation-by-user-activation');
      frame.onload = function(){
        overlay.setAttribute('class','frame-overlay loaded');
        setTimeout(function(){
          appWin.panel.content.removeChild(overlay);
        },200);
      };
      this.panel.content.appendChild(frame);

      return this;
    }
  };

  return AppWindow;
})();
var ProjectDetails = (function(){
  function ProjectDetails(serverObj){
    this.id = null;
    this.name = null;
    this.creatorID = null;
    this.isActive = false;
    this.limit = {};

    if(serverObj){
      this.fromJSON(serverObj);
    }
  };

  ProjectDetails.prototype = {
    fromJSON: function(serverObj){
      this.id = serverObj.id;
      this.name = serverObj.Name;
      this.creatorID = serverObj.CreatorID;
      this.isActive = serverObj.IsActive;
      return this;
    },
    setLimitDetails: function(serverObj){
      this.limit.apiLimit = +serverObj.rateLimit.usageLimit;
      this.limit.throttle = serverObj.rateLimit.throttle;
      this.limit.limitResetDate = new Date((+serverObj.rateLimit.resetUsageAt) * 1000);
      this.limit.apiUsage = {};
      this.limit.apiUsageTotal = 0;
      var proj = this;
      serverObj.rateLimit.CatalogueUsages.forEach(function(obj){
        proj.limit.apiUsageTotal += +obj.usage;
        proj.limit.apiUsage[obj.catalogueID] = +obj.usage;
      });
      return this;
    },
    setCTXPlugins: function(result){
      this.ctxPlugins = result;
      return this;
    }
  };

  return ProjectDetails;
})();
var ContextPlugin = (function(){
  function ContextPlugin(serverObj){
    this.id = null;
    this.name = null;
    this.iconURL = null;
    this.description= null;
    this.isReserved = false;
    this.isEnabled = false;
    this.attributes = [];


    if(serverObj){
      this.fromJSON(serverObj);
    }
  };

  ContextPlugin.prototype = {
    fromJSON: function(serverObj){
      this.id = serverObj.uid;
      this.name = serverObj.name;
      this.iconURL = serverObj.iconUrl;
      this.description = serverObj.description;
      this.isReserved = serverObj.isReserved;
      this.isEnabled = serverObj.tenantConfig.isEnabled;
      var attributeKeys = Object.keys(serverObj.values);
      this.attributes = attributeKeys.map(function(attributeKey){
        var attribute = serverObj.values[attributeKey];
        var retObj = {
          id: attributeKey,
          name: attribute.name,
          type: attribute.valueType,
          parameters: attribute.parameters?attribute.parameters.map(function(obj){
            return {
              index: obj.index,
              name: obj.key,
              description: obj.description,
              type: obj.valueType,
              _input: null
            };
          }):[],
          _input: null
        };

        if(retObj.type === ContextPlugin.BOOLEAN){
          retObj._input = false;
        }
        return retObj;
      });

      return this;
    },
    getValues: function(){
      var values = new CtxValues();
      values.gatherValues(this);
      return values;
    },
    setValues: function(ctxValues){
      ctxValues.applyValues(this);
      return this;
    },
    clearValues: function(){
      var view = this;
      this.attributes.forEach(function(attribute){
        if(attribute.type === ContextPlugin.BOOLEAN){
          attribute._input = false;
        } else{
          attribute._input = null;
        }
        attribute.parameters.forEach(function(param){
          param._input = null;
        });
      });
    }
  };

  ContextPlugin.BOOLEAN = ContextPlugin.prototype.BOOLEAN = 'bool';
  ContextPlugin.INTEGER = ContextPlugin.prototype.INTEGER = 'int';
  ContextPlugin.FLOAT = ContextPlugin.prototype.FLOAT = 'float';
  ContextPlugin.STRING = ContextPlugin.prototype.STRING = 'string';

  return ContextPlugin;
})();
var Theme = (function(){
  function Theme(serverObj, groupName){
    this.id = App.util.Obj.guid();
    this.groupName = groupName;
    this.mode = App.cfg.themeDefaults.mode;
    this.splashURL = undefined;
    this.appscreenURL = undefined;
    this.widgetIconURL = App.cfg.themeDefaults.widgetIconURL;
    this.primaryColor = App.cfg.themeDefaults.primaryColor;
    this.secondaryColor = App.cfg.themeDefaults.secondaryColor;
    this.tertiaryColor = App.cfg.themeDefaults.tertiaryColor;
    this.fgColor = App.cfg.themeDefaults.fgColor;
    this.fineGrainColor = {
      feedBG: null,
      pillsBG: null,
      tabbarBG: null,
      tabbarActiveBG: null,
      widgetBG: null,
      buttonBG: null
    };
    this.pillsEnabled = App.cfg.themeDefaults.pillsEnabled;
    this.pills = JSON.parse(JSON.stringify(App.cfg.themeDefaults.pills));
    this.tileStyle = JSON.parse(JSON.stringify(App.cfg.themeDefaults.tileStyle)) || {
      borderColor: '#e5e5e5',
      borderRadius: 4,
      enableShadow: true,
      sideMargin: 10
    };
    this.enableHeaderIcon = App.cfg.themeDefaults.enableHeaderIcon;

    if(serverObj){
      this.fromJSON(serverObj);
    }
  };

  Theme.prototype = {
    fromJSON: function(serverObj){
      if(serverObj.id){
        this.id = serverObj.id;
      }
      this.mode = serverObj.mode;
      this.splashURL = serverObj.splashURL;
      this.appscreenURL = serverObj.appscreenURL;
      this.widgetIconURL = serverObj.widgetIconURL;
      this.primaryColor = serverObj.primaryColor;
      this.secondaryColor = serverObj.secondaryColor;
      this.tertiaryColor = serverObj.tertiaryColor;
      this.fgColor = serverObj.fgColor;
      
      this.fineGrainColor.feedBG = serverObj.fineGrainColor?serverObj.fineGrainColor.feedBG:null;
      this.fineGrainColor.pillsBG = serverObj.fineGrainColor?serverObj.fineGrainColor.pillsBG:null;
      this.fineGrainColor.tabbarBG = serverObj.fineGrainColor?serverObj.fineGrainColor.tabbarBG:null;
      this.fineGrainColor.tabbarActiveBG = serverObj.fineGrainColor?serverObj.fineGrainColor.tabbarActiveBG:null;
      this.fineGrainColor.widgetBG = serverObj.fineGrainColor?serverObj.fineGrainColor.widgetBG:null;
      this.fineGrainColor.buttonBG = serverObj.fineGrainColor?serverObj.fineGrainColor.buttonBG:null;
      
      this.pillsEnabled = serverObj.hasOwnProperty('pillsEnabled')?serverObj.pillsEnabled:true;
      if(serverObj.pills){
        this.pills = serverObj.pills;
      }
      
      this.tileStyle.borderColor = serverObj.tileStyle?serverObj.tileStyle.borderColor:'#e5e5e5';
      this.tileStyle.borderRadius = serverObj.tileStyle?serverObj.tileStyle.borderRadius:4;
      this.tileStyle.enableShadow = serverObj.tileStyle?serverObj.tileStyle.enableShadow:true;
      this.tileStyle.sideMargin = serverObj.tileStyle?serverObj.tileStyle.sideMargin:10;
      
      this.enableHeaderIcon = serverObj.enableHeaderIcon;

      return this;
    },
    toJSON: function(){
      return {
        groupName: this.groupName,
        keyProperty: 'id',
        payload: {
          id: this.id,
          mode: this.mode,
          splashURL: this.splashURL,
          appscreenURL: this.appscreenURL,
          widgetIconURL: this.widgetIconURL,
          primaryColor: this.primaryColor,
          secondaryColor: this.secondaryColor,
          tertiaryColor: this.tertiaryColor,
          fgColor: this.fgColor,
          fineGrainColor: this.fineGrainColor,
          pillsEnabled: this.pillsEnabled,
          pills: this.pills,
          tileStyle: this.tileStyle,
          enableHeaderIcon: this.enableHeaderIcon
        }
      };
    }
  };

  Theme.FULLSCREEN = Theme.prototype.FULLSCREEN = 'fullscreen';
  Theme.EMBEDDED = Theme.prototype.EMBEDDED = 'embedded';
  Theme.WIDGET = Theme.prototype.WIDGET = 'widget';

  return Theme;
})();
var Profile = (function(){
  function Profile(serverObj){
    this.id = App.util.Obj.guid();
    this.name = '';
    this.description = '';
    this.color = '';
    this.iconURL = '';
    this.tmpState = null;
    this.ctxs = [];
    this.authType = 'anonymous';
    this.highlight = false;
    this.isDisabled = false;
    this.auth = {
      token: '',
      ref: ''
    };

    if(serverObj){
      this.fromJSON(serverObj);
    }
  };

  Profile.prototype = {
    saveState: function(){
      this.tmpState = this.toJSON();
    },
    restoreState: function(){
      if(this.tmpState){
        this.fromJSON(this.tmpState);
      }
    },
    fromJSON: function(serverObj){
      this.id = serverObj.id;
      this.name = serverObj.name;
      this.description = serverObj.desc;
      this.iconURL = serverObj.iconURL;
      this.color = serverObj.color;

      this.ctxs = serverObj.ctxs.map(function(ctx){
        return new CtxValues(ctx);
      }).filter(function(obj){
        if(!obj.ctx || !obj.ctx.id){
          console.error('Missing context plugin detected and removed from profile.','error');
          console.error('Please resave your profile: ' + serverObj.name);
          return false;
        }
        return true;
      });

      if(serverObj.authType){
        this.authType = serverObj.authType;
      }
      if(serverObj.auth){
        this.auth = serverObj.auth;
      }
      if(serverObj.hasOwnProperty('isDisabled')){
        this.isDisabled = serverObj.isDisabled;
      }
    },
    toJSON: function(){
      var retObj = {
        id: this.id,
        name: this.name,
        desc: this.description,
        iconURL: this.iconURL,
        color: this.color,
        ctxs: this.ctxs.map(function(ctx){
          return ctx.toJSON();
        }),
        authType: this.authType,
        auth: this.auth,
        isDisabled: this.isDisabled
      };

      return retObj;
    }
  };

  Profile.auth = Profile.prototype.auth = {
    OIDC: 'oidc',
    OKTA: 'okta',
    JWT: 'jwt',
    ANONYMOUS: 'anonymous',
    FLYBITS: 'flybits'
  };

  return Profile;
})();
var Profiles = (function(){
  function Profiles(serverObj, groupName){
    this.id = App.util.Obj.guid();
    this.groupName = groupName;
    this.list = [];

    if(serverObj){
      this.fromJSON(serverObj);
    }
  };

  Profiles.prototype = {
    fromJSON: function(serverObj){
      this.id = serverObj.id;
      this.list = serverObj.profiles.map(function(profile){
        return new Profile(profile);
      });

      return this;
    },
    toJSON: function(){
      return {
        groupName: this.groupName,
        keyProperty: 'id',
        payload: {
          id: this.id,
          profiles: this.list.map(function(profile){
            return profile.toJSON();
          })
        }
      };
    }
  };

  return Profiles;
})();
var CtxValues = (function(){
  var hasParams = function(params){
    for(var i = 0; i < params.length; i++){
      if(params[i].hasOwnProperty('_input') && params[i]._input !== null){
        return true;
      }
    }
    return false;
  }
  var getParamKey = function(params){
    var key = '';
    params.sort(function(a,b){
      return a.index - b.index;
    }).forEach(function(param){
      if(param.hasOwnProperty('_input') && param._input !== null){
        if(key !== ''){
          key += '.';
        }
        key += param._input;
      }
    });

    return key;
  }

  var castValue = function(type,value){
    if(type === ContextPlugin.INTEGER || type === ContextPlugin.FLOAT){
      return +value;
    }

    return value;
  }

  var getParamKeys = function(valueKeys, valueMap, attribute){
    var attrParamKeys = valueKeys.filter(function(key){
      return key.indexOf(attribute.id) > -1;
    });
    return attrParamKeys;
  }

  function CtxValues(serverObj){
    this.values = {};
    this.ctx = null;
    if(serverObj){
      this.fromJSON(serverObj);
    }
  };

  CtxValues.prototype = {
    fromJSON: function(serverObj){
      this.values = serverObj.values;
      if(App.store && App.store.project){
        var ctx = App.store.project.ctxPlugins.filter(function(plugin){
          return plugin.id === serverObj.ctxID;
        })[0];
        this.ctx = ctx;
        if(!ctx){
          App.toast('Cannot find plugin: '+serverObj.ctxID,'error');
          console.log('> missing plugin', serverObj.ctxID);
        }
      }
      return this;
    },
    toJSON: function(){
      var retObj = {
        ctxID: this.ctx.id,
        ctxName: this.ctx.name,
        ctxIconURL: this.ctx.iconURL,
        values: JSON.parse(JSON.stringify(this.values))
      };

      return retObj;
    },
    gatherValues: function(ctx){
      this.ctx = ctx;
      var ctxObj = this.values;
      ctx.attributes.forEach(function(attribute){
        if(attribute.hasOwnProperty('_input') && attribute._input !== null){
          var userValue = castValue(attribute.type, attribute._input);

          if(hasParams(attribute.parameters)){
            ctxObj[attribute.id+'.'+getParamKey(attribute.parameters)] = userValue;
          } else{
            ctxObj[attribute.id] = userValue;
          }
        }
      });
      return this.values;
    },
    applyValues: function(ctx){
      var valueMap = this.values;
      var valueKeys = Object.keys(valueMap);
      var view = this;

      ctx.attributes.forEach(function(attribute){
        var paramKeys = getParamKeys(valueKeys, valueMap, attribute);
        if(valueMap.hasOwnProperty(attribute.id)){
          attribute._input = valueMap[attribute.id];     
        } else if(paramKeys.length){
          var paramVals = paramKeys[0].split('.').slice(1);
          attribute.parameters.forEach(function(param, index){
            if(paramVals[index]){
              param._input = paramVals[index];
            }
          });
          attribute._input = valueMap[paramKeys[0]];
        }
      });
    }
  };

  return CtxValues;
})();
var Themes = (function(){
  function Themes(serverObj, groupName){
    this.id = App.util.Obj.guid();
    this.groupName = groupName;
    this.list = [];

    if(serverObj){
      this.fromJSON(serverObj);
    }
  };

  Themes.prototype = {
    fromJSON: function(serverObj){
      var model = this;
      this.id = serverObj.id;
      this.list = serverObj.themes.map(function(themeElem){
        return {
          name: themeElem.name,
          desc: themeElem.desc,
          theme: new Theme(themeElem.theme, themeElem.groupName)
        };
      });

      return this;
    },
    toJSON: function(){
      return {
        groupName: this.groupName,
        keyProperty: 'id',
        payload: {
          id: this.id,
          themes: this.list.map(function(themeElem){
            return {
              theme: themeElem.theme.toJSON().payload,
              name: themeElem.name,
              desc: themeElem.desc,
              groupName: themeElem.theme.groupName
            };
          })
        }
      };
    }
  };

  return Themes;
})();
var ZoneContainers = (function(){
  var stripContent = function(content, mode){
    var data = content.data.result && Array.isArray(content.data.result)?
               content.data.result[0].toJSON() : content.data;
    App.util.Content.flattenLocales(data);
    var retObj = {
      id: content.id,
      data: data,
      uiTemplate: '',
      style: '',
      styleStr: '',
      contentInfo: {
        id: content.id,
        labels: content.labels
      }
    };

    var uiObj = mode && mode === 'details'?content.detailsUI:content.defaultUI || {};
    retObj.uiTemplate = uiObj.layoutHTML;
    retObj.layout = uiObj.layout;
    retObj.style = uiObj.styleCSSURL;
    retObj.styleStr = uiObj.styleCSS;
    return retObj;
  };

  var generateTDHomePage = function(){
    return {
      header: {
        id: App.util.Obj.guid(1),
        cacheKey: App.util.Obj.guid(1),
        layoutStr: `
          <div class="td-header"> 
            <img src="https://file-manager.demo.flybits.com/file-manager/2DFF6962-14A7-4BD3-AB40-A0600D51FFEE.png" class="logo" />
            <div class="header-bar">
              <div class="title">Just for you</div>
            </div>
          </div>
        `,
        styleStr: /*css*/`
          .td-header {
            background-color: #1A5336;
          }
          
          .td-header .logo {
            width: 100%;
            display: block;
          }
          .header-bar{
            position: relative;
            padding: 0 16px 0;
            background-color: #F3F3F3;
          }
          .header-bar::before {
            content: '';
            position: absolute;
            top: 37px;
            left: 16px;
            right: 0;
            height: 1px;
            background-color: #CCCCCC;
            z-index: 1;
          }
          .header-bar::after {
            content: '';
            display: block;
            height: 0;
            clear: both
          }
          .header-bar .title{
            position: relative;
            float: left;
            cursor: pointer;
            font-size: 20px;
            padding: 20px 0 8px 0;
            padding-right: 10px;
            font-weight: bold;
            color: #1C1C1C;
            background-color: #F3F3F3;
            z-index: 2;
          }
        `,
        content: []
      },
      footer: {
        id: App.util.Obj.guid(1),
        cacheKey: App.util.Obj.guid(1),
        layoutStr: `
          <div class="footer-bar">
            <div class="view-more" v-on:click="emitAction('concierge://?zoneReferenceId=landerpage')">View all</div>
          </div>
          <div class="td-footer">
            <img src="https://file-manager.demo.flybits.com/file-manager/5700C320-6392-4815-BECA-57A8E993F08E.png" />
          </div>
        `,
        styleStr: /*css*/`
          .footer-bar{
            overflow: hidden;
            background-color: #F3F3F3;
          }
          .footer-bar .view-more{
            float: right;
            font-size: 16px;
            font-weight: bold;
            line-height: 16px;
            padding: 8px 16px 30px 0;
            cursor: pointer;
            color: #308523;
            padding-left: 20px;
          }
          .td-footer img {
            width: 100%;
            display: block;
          }
        `,
        content: []
      },
    };
  };
  var generateTDHeader = function(backZoneRefID, title){
    var pageTitle = title || 'TD for Me';
    var actionStr = backZoneRefID === 'back'?'back://':"concierge://?container=configured&zoneReferenceId="+backZoneRefID;
    return {
      id: App.util.Obj.guid(1),
      cacheKey: App.util.Obj.guid(1),
      layoutStr: `
        <div class="td-header-small">
          <div class="back-btn" v-on:click="emitAction('${actionStr}')">‹</div>
          <div class="page-title">${pageTitle}</div>
        </div>
      `,
      styleStr: /*css*/`
        .td-header-small{
          position: relative;
          background-color: #018701;
          padding-top: 40px;
          padding-bottom: 10px;
          color: white;
        }
        .td-header-small .back-btn{
          position: absolute;
          left: 0;
          top: 40px;
          line-height: 40px;
          width: 40px;
          text-align: center;
          font-size: 35px;
          font-weight: bold;  
          cursor: pointer;
        }
        .td-header-small .back-btn:active,.td-header-small .back-btn:focus{
          background-color: #135131;
        }
        
        .td-header-small .page-title{
          text-align: center;
          font-size: 18px;
          line-height: 40px;
          font-weight: bold;
        }
        .details-page.info .inner-scroll{
          top: 90px !important;
        }
      `,
      content: []
    }
  };


  function ZoneContainers(json){
    this.fromJSON(json);
  };

  ZoneContainers.prototype = {
    fromJSON: function(json){
      json = json || {};
      var contentMap = this.contentMap = {};

      this.zones = json.zones?json.zones.map(function(z){
        var zObj = {
          id: z.id,
          refID: z.referenceID,
          name: z.name,
          labels: z.labels,
          height: z.height,
          containers: z.modulesIDs?z.modulesIDs.map(function(mID){
            var module = json && json.modules?json.modules.filter(function(m){
              return m.id === mID;
            })[0]:null;

            if(module){
              var container = {
                id: module.id,
                cacheKey: App.util.Obj.guid(1),
                name: module.name,
                layoutStr: module.layoutHTML,
                layout: module.layout,
                style: module.styleCSSURL,
                styleStr: module.styleCSS,
                query: module.query,
                allowDeprioritization: module.allowDeprioritization,
                content: module.contentIDs?module.contentIDs.map(function(cID){
                  var cInstance = json && json.data?json.data.filter(function(c){
                    return c.id === cID;
                  })[0]:null;

                  if(cInstance){
                    cInstance = new Flybits.Content(cInstance);
                    contentMap[cID] = cInstance;
                    var strippedContent = stripContent(cInstance);
                    return strippedContent;
                  }
                  return null;
                }):[]
              };
              return container;
            }

            return null;
          }):[],
        };
        return zObj;
      }):[];
    },
    toInjectPayload: function(zoneRefID){
      var zone = this.zones.filter(function(z){
        return z.refID === zoneRefID;
      })[0];

      zone = zone?JSON.parse(JSON.stringify(zone)):null;
      if(zone && !App.cfg.themeDefaults.disableTDHome){
        if(zoneRefID === 'homepage' || zoneRefID === 'carousel'){
          var homeUI = generateTDHomePage();
          zone.containers.unshift(homeUI.header);
          zone.containers.push(homeUI.footer);
        } else if(zoneRefID === 'landerpage' || zoneRefID === 'lander'){
          var headerUI = generateTDHeader(App.cfg.HOMEZONEREF || 'homepage');
          zone.containers.unshift(headerUI);
        }
      }

      console.log('> refresh', zone);
      return zone;
    },
    toDetailsPayload: function(contentID, pageTitle){
      var content = this.contentMap[contentID];
      if(!content){
        console.log('> no content details found', contentID);
        return;
      }

      return ZoneContainers.createDetailsPayload(content, pageTitle);
    },
    toOverlayPayload: function(contentID){
      var content = this.contentMap[contentID];
      if(!content){
        console.log('> no content details found', contentID);
        return;
      }

      return ZoneContainers.createOverlayPayload(content);
    }
  };
  ZoneContainers.createDetailsPayload = ZoneContainers.prototype.createDetailsPayload = function(contentInstance, pageTitle){
    var tmpZone = {
      id: App.util.Obj.guid(2),
      refID: 'details',
      name: 'Content Details',
      containers: [{
        id: App.util.Obj.guid(),
        cacheKey: App.util.Obj.guid(1),
        layout: 'vertical',
        content: [stripContent(contentInstance, 'details')]
      }]
    }

    if(!App.cfg.themeDefaults.disableTDHome){
      var headerUI = generateTDHeader('back', pageTitle);
      tmpZone.containers.unshift(headerUI);
    }
    console.log('> tmpZone', tmpZone);
    return tmpZone;
  };

  ZoneContainers.createOverlayPayload = ZoneContainers.prototype.createOverlayPayload = function(contentInstance){
    var tmpZone = {
      id: App.util.Obj.guid(2),
      refID: 'overlay',
      name: 'Overlay',
      containers: [{
        id: App.util.Obj.guid(),
        cacheKey: App.util.Obj.guid(1),
        layout: 'overlay',
        content: [stripContent(contentInstance, 'details')]
      }]
    }

    console.log('> tmpZone', tmpZone);
    return tmpZone;
  }

  return ZoneContainers;
})();
var NavStack = (function(){
  function NavStack(frameController){
    this.stack = [];
    this.frameController = frameController;
    this.isPolling = false;
    this.timer = null;
    this.delay = 3000;
  };

  NavStack.prototype = {
    startPoll: function(){
      this.isPolling = true;
      this.poll();
    },
    stopPoll: function(){
      this.isPolling = false;
      clearTimeout(this.timer);
    },
    togglePolling: function(){
      if(this.isPolling){
        this.stopPoll();
      } else {
        this.startPoll();
      }
    },
    poll: function(){
      var view = this;
      this.reload().catch(function(e){
        console.log('> failed to retrieve')
      }).then(function(){
        view.timer = setTimeout(function(){
          if(view.isPolling){
            view.poll();
          }
        }, view.delay)
      })
    },
    reload: function(){
      var def = new Flybits.Deferred();

      if(this.stack.length > 0){
        this.load(this.stack[this.stack.length - 1]).then(function(){
          def.resolve();
        }).catch(function(e){
          console.log('> failed to refresh', e);
          def.reject(e);
        });
      } else{
        def.reject();
      }

      return def.promise;
    },
    load: function(navElem){
      var def = new Flybits.Deferred();
      var opts = navElem.opts || {};
      var view = this;
      var {zoneRef,contentID,skipCache,pageTitle} = opts;

      if(!navElem){
        def.reject();
        return def.promise;
      }

      if(navElem.type === NavStack.DETAILS){
        if(skipCache){
          view.frameController.isPhoneLoading = true;
          if(opts.overlay){
            App.store.getOverlay(contentID).then(function(zonePayload){
              view.frameController.injectOverlay(zonePayload);
              def.resolve();
            }).catch(function(e){
              console.log('> oh no', e);
              def.reject(e);
            }).then(function(){
              view.frameController.isPhoneLoading = false;
            })
          } else{
            App.store.getDetails(contentID, {pageTitle:pageTitle}).then(function(zonePayload){
              view.frameController.inject(zonePayload);
              def.resolve();
            }).catch(function(e){
              console.log('> oh no', e);
              def.reject(e);
            }).then(function(){
              view.frameController.isPhoneLoading = false;
            })
          }
        } else{
          if(opts.overlay){
            var zonePayload = App.store.getCachedOverlay(contentID);
            if(zonePayload){
              view.frameController.injectOverlay(zonePayload);
              def.resolve();
            } else{
              console.log('> no valid content found', contentID);
              def.reject();
            }
          } else{
            var zonePayload = App.store.getCachedDetails(contentID, pageTitle);
            if(zonePayload){
              view.frameController.inject(zonePayload);
              def.resolve();
            } else{
              console.log('> no valid content found', contentID);
              def.reject();
            }
          }
        }
      } else if(navElem.type === NavStack.CONCIERGE){
        if(!skipCache){
          var zonePayload = App.store.getCachedZone(zoneRef);
          if(zonePayload){
            if(opts.overlay){
              this.frameController.injectOverlay(zonePayload);
            } else{
              this.frameController.inject(zonePayload);
            }
            def.resolve();
          } else{
            console.log('> no valid zone found', zoneRef);
            def.reject();
          }
        } else{
          view.frameController.isPhoneLoading = true;
          App.store.getZonesContent({
            zoneRef: zoneRef
          }).then(function(zonePayload){
            if(opts.overlay){
              view.frameController.injectOverlay(zonePayload);
            } else{
              view.frameController.inject(zonePayload);
            }
            def.resolve();
          }).catch(function(e){
            console.error('> uhoh', e);
          }).then(function(){
            view.frameController.isPhoneLoading = false;
          })
        }
      }

      return def.promise
    },
    clear: function(){
      this.stack = [];
    },
    back: function(opts){
      opts = opts || {};
      if(this.stack.length <=1){
        return;
      }

      const curNavElem = this.stack[this.stack.length -1];
      if(curNavElem?.opts.overlay && this.frameController.isOverlayOpen){
        this.stack.pop();
        this.frameController.closeOverlay();
        return Promise.resolve();
      }

      this.stack.pop();
      var navElem = this.stack[this.stack.length -1];
      if(!opts.noLoader){
        App.evt.emit(App.actions.FRAMELOADING, true);
      }
      var loadPromise = this.load(navElem)
      loadPromise.catch(function(){}).then(function(){
        if(!opts.noLoader){
          App.evt.emit(App.actions.FRAMELOADING, false);
        }
      });
      return loadPromise;
    },
    push: function(type, opts){
      const curNavElem = this.stack[this.stack.length -1];
      if(curNavElem?.opts.overlay && this.frameController.isOverlayOpen){
        this.stack.pop();
        this.frameController.closeOverlay();
      }
      
      var navElem = {
        type: type,
        opts: opts
      };
      var nav = this;
      nav.stopPoll();
      this.stack.push(navElem);
      if(opts.skipCache && !opts.noLoader && !opts.overlay){
        App.evt.emit(App.actions.FRAMELOADING, true);
      }

      var def = new Flybits.Deferred();
      if(opts.delay){
        setTimeout(function(){
          nav.load(navElem).then(function(){
            def.resolve();
          }).catch(function(e){
            def.reject(e);
          })
        }, 1000);
      } else{
        nav.load(navElem).then(function(){
          def.resolve();
        }).catch(function(e){
          def.reject(e);
        })
      }

      def.promise.catch(function(){}).then(function(){
        if(opts.skipCache && !opts.noLoader && !opts.overlay){
          App.evt.emit(App.actions.FRAMELOADING, false);
        }
      });
      return def.promise;
    },
    replace: function(type, opts){
      this.clear();
      return this.push(type, opts);
    }
  };

  NavStack.DETAILS = 'details';
  NavStack.CONCIERGE = 'concierge';

  return NavStack;
})();
var LoadingView = Vue.extend({
  template:'#view-loading',
});
Vue.component('loading-view',LoadingView);
var LoaderBar = Vue.extend({
  template:'#loader-bar',
});
Vue.component('loader-bar',LoaderBar);

var LoginModal = Vue.extend({
  template:'#login-modal',
  data: function(){
    return {
      isLoading: false,
      display: false,
      email: '',
      password: '',
      deferred: null,
      error: '',
    };
  },
  computed: {
    hasValue: function(){
      return this.email && this.password;
    }
  },
  watch: {
    email: function(newVal, oldVal){
      this.error = '';
    },
    password: function(newVal, oldVal){
      this.error = '';
    }
  },
  methods: {
    showControl: function(req){
      var view = this;
      this.display = req.isOpen;
      
      if(req.isOpen){
        Flybits.Session.disconnect();
        setTimeout(function(){
          view.$el.querySelector('.entry-field.email').focus();
        },1);
      } else{
        view.reset();
      }
      if(req.deferred){
        this.deferred = req.deferred;
      }
    },
    login: function(){
      if(this.isLoading || !this.hasValue){
        return;
      }

      this.isLoading = true;
      if(!this.email){
        this.error = "Email is required";
        this.isLoading = false;
        return;
      }
      if(!this.password){
        this.error = "Password is required";
        this.isLoading = false;
        return;
      }

      var view = this;
      Flybits.Session.connect(new Flybits.idp.FlybitsIDP({
        email: this.email,
        password: this.password,
        projectID: App.cfg.PROJECTID
      })).then(function(){
        if(view.deferred){
          view.deferred.resolve();
        }
        view.showControl({isOpen:false});
      }).catch(function(e){
        view.error = e.firstError().message;
        if(view.deferred){
          view.deferred.reject();
        }
      }).then(function(){
        view.isLoading = false;
      })
    },
    reset: function(){
      this.email = '';
      this.password = '';
      this.error = '';
      this.deferred = null;
    }
  },
  mounted: function(){
    var view = this;
    if(App){
      App.ready.then(function(){
        App.evt.on(App.actions.PROMPTLOGIN,view.showControl);
      });
    } else{
      console.log('> warning: login-modal not registered to event bus')
    }
  },
  beforeDestroy: function(){
    App.evt.off(App.actions.PROMPTLOGIN, this.showControl);
  }
});
Vue.component('login-modal',LoginModal);

var ApiUsage = Vue.extend({
  template:'#api-usage',
  props: {
    usage: Object,
    max: Number
  },
  computed: {
    total: function(){
      var view = this;
      if(!this.usage){
        return 0;
      }
      var segmentKeys = Object.keys(this.usage);
      return segmentKeys.map(function(key){
        return +view.usage[key];
      }).reduce(function(acc, cur){
        return acc + cur;
      },0);
    },
    segments: function(){
      var view = this;
      if(!this.usage){
        return [];
      }
      var segmentKeys = Object.keys(this.usage);
      return segmentKeys.map(function(key){
        var value = +view.usage[key];
        var percentage = +(value / view.max * 100).toFixed(2);
        if(value > 0 && percentage < 1 && (view.total / view.max * 100) < 90){
          percentage = 0.5;
        }
        return {
          key: key,
          value: value,
          styleWidth: percentage+'%',
          color: '#' + view.intToRGB(view.hashCode(key))
        };
      })
    }
  },
  methods: {
    hashCode: function(str){
      var hash = 0;
      for( var i = 0; i < str.length; i++){
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      return hash;
    },
    intToRGB: function(i){
      var c = (i & 0x00FFFFFF).toString(16).toUpperCase();

      return "00000".substring(0, 6 - c.length) + c;
    },
    segmentLabel: function(segment){
      return segment.key + ": " + segment.value.toLocaleString();
    }
  }
});
Vue.component('api-usage',ApiUsage);

var ThemeEditor = (function(){
  var MODEPICK = "pick";
  var MODESAVE = "save";
  var MODESAVEPICK = "savepick";

  var debounce = (function(){
    return function debounce(func, wait, immediate) {
      var timeout, args, context, timestamp, result;
      if (null == wait) wait = 100;

      function later() {
        var last = Date.now() - timestamp;

        if (last < wait && last >= 0) {
          timeout = setTimeout(later, wait - last);
        } else {
          timeout = null;
          if (!immediate) {
            result = func.apply(context, args);
            context = args = null;
          }
        }
      };

      var debounced = function () {
        context = this;
        args = arguments;
        timestamp = Date.now();
        var callNow = immediate && !timeout;
        if (!timeout) timeout = setTimeout(later, wait);
        if (callNow) {
          result = func.apply(context, args);
          context = args = null;
        }

        return result;
      };

      debounced.clear = function () {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
      };

      debounced.flush = function () {
        if (timeout) {
          result = func.apply(context, args);
          context = args = null;

          clearTimeout(timeout);
          timeout = null;
        }
      };

      return debounced;
    };
  })();

  return Vue.extend({
    template:'#theme-editor',
    props: {
      theme: Object,
      themes: Object
    },
    data: function(){
      return {
        isLoading: false,
        picker: {
          mode: MODEPICK,
          isOpen: false,
          isSaveOpen: false,
          tmpThemeName: '',
          tmpThemeDesc: '',
          lazyload: null
        },
        rawSearchKey: '',
        searchKey: '',
      };
    },
    computed: {
      pickerHeader: function(){
        var str = 'Choose Theme';
        if(this.picker.mode === MODEPICK){
          str = 'Choose Theme';
        } else if(this.picker.mode === MODESAVE){
          str = 'Save Theme As';
        } else if(this.picker.mode === MODESAVEPICK){
          str = 'Overwrite Theme';
        }

        return str;
      },
      filteredThemes: function(){
        var view = this;
        return this.themes? this.themes.list.filter(function(theme){
          if(!view.searchKey){
            return true;
          }
          var str = '';
          if(theme.name){
            str += theme.name.toLowerCase();
          }
          if(theme.desc){
            str += theme.desc.toLowerCase();
          }
          return str.indexOf(view.searchKey.toLowerCase()) > -1;
        }): [];
      }
    },
    watch: {
      'theme.mode': function(newVal, oldVal){
        if(newVal){
          this.syncSelected();
        }
      },
      'picker.mode': function(newVal, oldVal){
        console.log('>', newVal, oldVal);
        if(newVal && newVal !== MODESAVE){
          this.resetLazyLoad();
        }
      },
      'picker.isOpen': function(newVal, oldVal){
        if(newVal && this.picker.mode !== MODESAVE){
          this.resetLazyLoad();
        }
      },
      rawSearchKey: function(newVal, oldVal){
        this.updateSearch();
      },
      searchKey: function(newVal, oldVal){
        this.updateLazyLoad();
      },
    },
    methods: {
      updateSearch: debounce(function(){
        this.searchKey = this.rawSearchKey;
      }, 250),
      removeBGImg: function(){
        var list = this.$refs.themeslist;
        if(list){
          var items = list.querySelectorAll('.asset-img');
          if(items.length){
            [].forEach.call(items, function(obj){
              obj.removeAttribute('data-was-processed');
            });
          }
        }
      },
      updateLazyLoad: function(){
        var view = this;
        setTimeout(function(){
          if(view.picker.lazyload && view.$refs.themeslist){
            view.removeBGImg();
            view.picker.lazyload.update();
          }
        }, 100);
      },
      resetLazyLoad: function(){
        var view = this;
        
        setTimeout(function(){
          if(!view.$refs.themeslist){
            return;
          }
          if(view.picker.lazyload){
            view.picker.lazyload.destroy();
          }
          view.picker.lazyload = new LazyLoad({
            container: view.$refs.themeslist,
            elements_selector: '.asset-img'
          });
        }, 100);
      },
      setMode: function(mode){
        this.theme.mode = mode;
      },
      syncSelected: function(){
        var mode = this.theme.mode;
        var view = this;
        Vue.nextTick(function(){
          view.$el.querySelectorAll('.mode').forEach(function(elem){
            if(elem.classList.contains(mode)){
              elem.classList.add('selected');
            } else{
              elem.classList.remove('selected');
            }
          });
        });
      },
      apply: function(){
        var view = this;
        var start = Date.now();
        view.isLoading = true;
        Store.upsertTheme(this.theme).catch(function(){
          console.log('> uh oh');
        }).then(function(){
          var end = Date.now();
          var diff = end - start;
          if(diff < 800){
            setTimeout(function(){
              view.isLoading = false;  
            }, 800 - diff);
          } else{
            view.isLoading = false;
          }
        });
      },
      setThemePickMode: function(mode){
        this.picker.mode = mode;
        if(mode === MODEPICK){
          this.picker.isOpen = true;
        } else if(mode === MODESAVE){
          this.picker.isOpen = true;
          this.picker.isSaveOpen = true;
        } else if(mode === MODESAVEPICK){
          this.picker.isOpen = true;
          this.picker.isSaveOpen = false;
        }
      },
      openThemePicker: function(){
        var view = this;
        this.setThemePickMode(MODEPICK);
        setTimeout(function(){
          view.$refs.searchField.focus();
        },10);
      },
      openSave: function(){
        this.setThemePickMode(MODESAVE);
      },
      savePick: function(){
        this.setThemePickMode(MODESAVEPICK);
      },
      clearSearch: function(){
        this.rawSearchKey = '';
      },
      cancel: function(){
        this.picker.isOpen = false;
        this.picker.isSaveOpen = false;
        this.picker.tmpThemeDesc = '';
        this.picker.tmpThemeName = '';
        if(this.picker.lazyload){
          this.picker.lazyload.destroy();
        }
        this.clearSearch();
      },
      saveNewTheme: function(){
        var copy = this.theme.toJSON().payload;
        copy.id = App.util.Obj.guid();
        var retObj = {
          theme: new Theme(copy, this.theme.groupName),
          name: this.picker.tmpThemeName,
          desc: this.picker.tmpThemeDesc
        };

        this.themes.list.push(retObj);
        this.isLoading = true;
        var view = this;
        Store.upsertThemes(this.themes).then(function(){
          view.cancel();
        }).catch(function(e){}).then(function(){
          view.isLoading = false;
        });
      },
      selectTheme: function(themeElem){
        if(this.picker.mode === MODEPICK){
          var copy = themeElem.theme.toJSON().payload;
          delete copy.id;
          this.theme.fromJSON(copy);
          this.cancel();
        } else if(this.picker.mode === MODESAVEPICK){
          var view = this;
          themeElem.theme.fromJSON(this.theme.toJSON().payload);
          themeElem.name = this.picker.tmpThemeName;
          themeElem.desc = this.picker.tmpThemeDesc;
          this.isLoading = true;
          Store.upsertThemes(this.themes).then(function(){
            view.cancel();
          }).catch(function(e){}).then(function(){
            view.isLoading = false;
          });
        }
      },
      deleteTheme: function(themeElem){
        App.util.Obj.removeObject(this.themes.list, themeElem);

        this.isLoading = true;
        var view = this;
        Store.upsertThemes(this.themes).catch(function(e){}).then(function(){
          view.isLoading = false;
        });
      },
      removeCategory: function(pill){
        App.util.Obj.removeObject(this.theme.pills,pill);
      },
      addCategory: function(){
        this.theme.pills.push({
          displayName: '',
          label: ''
        });
      }
    },
  });
})();
Vue.component('theme-editor',ThemeEditor);

var ProfilesEditor = (function(){
  var getExistingCTXValue = function(list, ctxvalue){
    return list.filter(function(valueObj){
      return ctxvalue && valueObj.ctx.id === ctxvalue.ctx.id;
    })[0];
  }; 

  return Vue.extend({
    template:'#profiles-editor',
    props: {
      profiles: Object
    },
    data: function(){
      return {
        modWindowOpen: false,
        tmpProfile: null,
        isLoading: false
      };
    },
    computed: {
      isTmpNew: function(){
        var view = this;
        var existing = this.profiles?this.profiles.list.filter(function(obj){
          return view.tmpProfile && obj.id === view.tmpProfile.id;
        })[0]:undefined;

        return !existing;
      },
    },
    methods: {
      closeModify: function(){
        this.tmpProfile = null;
        this.modWindowOpen = false;
      },
      modifyProfile: function(profile){
        this.tmpProfile = profile;
        this.tmpProfile.saveState();
        this.modWindowOpen = true;
      },
      modifyCTX: function(value){
        var view = this;
        var def = new Flybits.Deferred();
        App.evt.emit(App.actions.OPENCTXPICKER,{
          value: value,
          deferredPromise: def,
        });
        def.promise.then(function(value){
          var existing = getExistingCTXValue(view.tmpProfile.ctxs,value);

          if(value instanceof CtxValues && !existing){
            view.tmpProfile.ctxs.push(value);
          } else if(existing){
            existing.values = value.values;
          }
        });
      },
      deleteCTX: function(value){
        if(value instanceof CtxValues){
          App.util.Obj.removeObject(this.tmpProfile.ctxs, value, function(obj){
            return obj.ctx.id === value.ctx.id;
          });
        }
      },
      deleteProfile: function(profile){
        var view = this;
        App.util.Obj.removeObject(this.profiles.list,profile, function(obj){
          return obj.id === profile.id;
        });
        this.isLoading = true;
        App.store.upsertProfiles(this.profiles).then(function(){
          console.log('> yay', profile);
          view.closeModify();
        }).catch(function(e){
          console.log('> uh oh');
        }).then(function(){
          view.isLoading = false;
        });
      },
      updateProfile: function(profile){
        var view = this;
        this.isLoading = true;
        App.store.upsertProfiles(this.profiles).then(function(){
          console.log('> yay', profile);
          App.toast('Profiles updated.');
        }).catch(function(e){
          console.log('> uh oh');
          App.toast('Profiles failed to update.','error');
        }).then(function(){
          view.isLoading = false;
        });
      },
      moveUp: function(profile){
        var $el = this;
        var index = this.profiles.list.indexOf(profile);
        var newIndex = index - 1;
        if(newIndex >= 0){
          profile.highlight = true;
          setTimeout(function(){
            App.util.Obj.moveItem($el.profiles.list, index, newIndex);
            App.store.upsertProfiles($el.profiles).catch(function(e){
              App.util.Obj.moveItem($el.profiles.list, newIndex, index);
              console.log('> move up failed', e);
              App.toast('Move failed to save', 'error');
            });
            setTimeout(function(){
              profile.highlight = false;
            },1);
          }, 150);
        }
      },
      moveDown: function(profile){
        var $el = this;
        var index = this.profiles.list.indexOf(profile);
        var newIndex = index + 1;
        if(newIndex < this.profiles.list.length){
          profile.highlight = true;
          setTimeout(function(){
            App.util.Obj.moveItem($el.profiles.list, index, newIndex);
            App.store.upsertProfiles($el.profiles).catch(function(e){
              App.util.Obj.moveItem($el.profiles.list, newIndex, index);
              console.log('> move down failed', e);
              App.toast('Move failed to save', 'error');
            });
            setTimeout(function(){
              profile.highlight = false;
            },1);
          }, 150);
        }
      },
      addProfileTrigger: function(){
        this.modifyProfile(new Profile());
      },
      cancelModify: function(){
        if(this.tmpProfile){
          this.tmpProfile.restoreState();
        }
        this.closeModify();
      },
      saveModify: function(){
        var view = this;
        if(this.isTmpNew){
          this.profiles.list.push(this.tmpProfile);
        }
        var start = Date.now();
        var end;
        this.isLoading = true;
        App.store.upsertProfiles(this.profiles).then(function(){
          console.log('> yay', view.profiles);
          end = Date.now();
          var diff = end - start;
          if(diff < 800){
            setTimeout(function(){
              view.closeModify();
            }, 800 - diff);
          } else{
            view.closeModify();
          }
        }).catch(function(e){
          end = Date.now();
          console.log('> uh oh');
        }).then(function(){
          var diff = end - start;
          if(diff < 800){
            setTimeout(function(){
              view.isLoading = false;  
            }, 800 - diff);
          } else{
            view.isLoading = false;
          }
        });
      }
    }
  });
})();
Vue.component('profiles-editor',ProfilesEditor);

var ColorPicker = Vue.extend({
  template:'#color-picker',
  props: {
    value: String,
    reset: Boolean
  },
  data: function(){
    return {
      picker: null,
      previewColor: null
    };
  },
  watch: {
    value: function(newVal, oldVal){
      this.picker.setColor(newVal);
      this.previewColor = newVal;
    }
  },
  methods: {
    setColor: function(color){
      this.$emit('input',color);
      this.previewColor = color;
    },
    clear: function(){
      this.setColor(null);
    }
  },
  mounted: function(){
    var view = this;
    this.picker = new Picker({
      parent: this.$el.querySelector('.preview'),
      alpha: false,
      onDone: function(colorObj){
        view.setColor(colorObj.hex.substr(0,7));
      }
    });

    if(this.value){
      this.picker.setColor(this.value);
      this.previewColor = this.value;
    }
  }
});
Vue.component('color-picker',ColorPicker);

var ImageManager = (function(){
  // requires cropperjs
  var IMGHOST;

  var ImageFile = (function(){
    var StyleState = (function(){
      function StyleState(opts){
        if(opts){
          this.fromJSON(opts);
        }
      }
      StyleState.prototype.fromJSON = function(opts){
        this.grayscale = opts.hasOwnProperty('grayscale')?opts.grayscale:false;
        this.blur = opts.hasOwnProperty('blur')?opts.blur:0;
        this.rotate = opts.hasOwnProperty('rotate')?opts.rotate:0;
        this.crop = opts.crop?JSON.parse(JSON.stringify(opts.crop)):null;
        
        return this;
      };
      StyleState.prototype.toJSON = function(){
        var retObj = {
          grayscale: this.grayscale,
          blur: +this.blur,
          rotate: +this.rotate
        };
        if(this.crop){
          retObj.crop = JSON.parse(JSON.stringify(this.crop));
        }
        return retObj;
      };
      StyleState.prototype.equals = function(styleState){
        return this.grayscale === styleState.grayscale &&
               this.blur === styleState.blur &&
               this.rotate === styleState.rotate &&
               this.crop == styleState.crop;
      };
      StyleState.copy = StyleState.prototype.copy = function(styleState){
        return new StyleState(styleState);
      };

      return StyleState;
    })();

    function ImageFile(serverObj){
      this.style = new StyleState();
      
      if(serverObj){
        this.fromJSON(serverObj);
      }
    }

    ImageFile.prototype.setStyle = function(styleState){
      this.style.fromJSON(styleState.toJSON());
    };

    ImageFile.prototype.toJSON = function(){
      var retObj = {
        id: this.id,
        url: this.url,
        friendlyName: this.name,
        extension: this.extension
      };
      if(this.uploadedAt){
        retObj.uploadedAt = Math.round(this.uploadedAt.getTime()/1000);
      }
      if(this.size){
        retObj.size = this.size;
      }

      return retObj;
    };

    ImageFile.prototype.fromJSON = function(serverObj){
      this.id = serverObj.id;
      this.url = serverObj.url;
      if(serverObj.uploadedAt){
        this.uploadedAt = new Date(serverObj.uploadedAt * 1000);
        this.uploadedAtStr = this.uploadedAt.getShortMonthName()+' '+this.uploadedAt.getDate()+', '+this.uploadedAt.getFullYear();
      }
      this.name = serverObj.friendlyName;
      this.extension = serverObj.extension;
      if(serverObj.size){
        this.size = serverObj.size;
        this.sizeStr = ImageFile.generateSizeStr(this.size);
      }
      this.resolutionStr = '';
      this.dimensions = {
        width: 0,
        height: 0
      };
      
      var tmpImg = document.createElement('img');
      tmpImg.style.position = 'fixed';
      tmpImg.style.left = '-1999px';
      tmpImg.style.opacity = 0;
      tmpImg.src = this.url;
      document.body.appendChild(tmpImg);
      
      var file = this;
      tmpImg.onload = function(){
        file.dimensions.width = tmpImg.naturalWidth;
        file.dimensions.height = tmpImg.naturalHeight;
        
        document.body.removeChild(tmpImg);
      };
    };

    ImageFile.generateSizeStr = function(rawSize){
      if(rawSize < 1000){
        return rawSize + ' B';
      }
      if(rawSize < 1000000){
        return (rawSize/1000).toFixed(1) + ' KB';
      } 
      if(rawSize < 1000000000){
        return (rawSize/1000000).toFixed(1) + ' MB';
      }
      if(rawSize < 1000000000000){
        return (rawSize/1000000000).toFixed(1) + ' GB';
      }
      return '';
    };


    ImageFile.StyleState = StyleState;
    return ImageFile;
  })();

  var ImageStore = (function(){
    function ImageStore(options){
      options = options || {};
      this.offset = -1;
      this.total = 0;
      this.limit = options.limit || 20;;
      this.images = [];
      this.isLoading = false;
    }

    ImageStore.prototype.getMore = function(){
      if(!this.hasMore()){
        return Promise.reject();
      }

      if(this.offset === -1){
        this.offset = 0;
      } else{
        this.offset = this.offset + this.limit;
      }

      var store = this;
      var def = new Flybits.Deferred();
      var url = IMGHOST + "?limit="+this.limit+"&offset="+this.offset;
      this.isLoading = true;
      Flybits.util.Api.flbFetch(url).then(function(resp){
        store.offset = resp.body.pagination.offset;
        store.total = resp.body.pagination.totalRecords;

        var existingImgKeys = store.images.map(function(obj){
          return obj.id;
        });
        var newImgs = resp.body.data.map(function(obj){
          return new ImageFile(obj);
        }).filter(function(obj){
          return existingImgKeys.indexOf(obj.id) < 0;
        });
        store.images.push.apply(store.images,newImgs);
        def.resolve(store.images);
      }).catch(function(e){
        def.reject(e);
      }).then(function(){
        store.isLoading = false;
      });

      return def.promise;
    };

    ImageStore.prototype.hasMore = function(){
      return this.offset === -1 || (this.offset + this.limit) < this.total;
    };

    ImageStore.prototype.deleteImage = function(imageFile){
      var def = new Flybits.Deferred();
      var url = IMGHOST + '/' + imageFile.id;
      var store = this;

      Flybits.util.Api.flbFetch(url,{
        method: 'DELETE',
        respType: 'none'
      }).then(function(){
        App.util.Obj.removeObject(store.images,imageFile,function(obj){
          return obj.id === imageFile.id;
        });
        def.resolve();
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    };
  
    ImageStore.prototype.insertImage = function(imageFile){
      var keys = this.images.map(function(obj){
        return obj.id;
      });

      if(keys.indexOf(imageFile.id) < 0){
        this.images.push(imageFile);
      }
    };

    return ImageStore;
  })();
  
  var UploadManager = (function(){
    return {
      uploadFile: function(opts){
        opts = opts || {onfilechange:function(){}};
        var def = new Flybits.Deferred();
        var fbFileUploadURL = IMGHOST + '/upload';

        window.allUpload({
          targetURL: App.cfg.PIXELHOST+'/upload?callback='+window.location.origin+'/noop.html',
          acceptStr: 'image/*',
          fileParamName: 'image',
          isResponseInQueryString: true,
          onfilechange: opts.onfilechange,
          formArgs: App.util.Obj.toStringParams({
            proxyTarget: fbFileUploadURL,
            proxyFileParam: 'file',
            proxyHeaders: {
              'X-Authorization': Flybits.Session.userToken
            },
            proxyParams: {
              isPrivate: false
            },
          }),
        }).then(function(resp){
          try {
            var json = JSON.parse(resp.data);
            def.resolve(json);
          } catch(exception) {
            // invalid JSON
            def.reject(exception);
          }

        }).catch(function(e){
          def.reject(e);
        });

        return def.promise;
      },
      uploadURL: function(opts){
        opts = opts || {};
        var def = new Flybits.Deferred();
        var fbFileUploadURL = IMGHOST + '/upload';
        var proxyURL = App.cfg.PIXELHOST + '/transform';

        if(!opts.url){
          return Promise.reject();
        }

        Flybits.util.Api.fetch(proxyURL,{
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          respType: 'json',
          body: JSON.stringify({
            image: opts.url,
            proxyTarget: fbFileUploadURL,
            proxyFileParam: 'file',
            proxyHeaders: {
              'X-Authorization': Flybits.Session.userToken
            },
            proxyParams: {
              isPrivate: false
            }
          })
        }).then(function(resp){
          def.resolve(resp.body);
        }).catch(function(e){
          def.reject(e);
        });

        return def.promise;
      },
      transform: function(src, styleState){
        var def = new Flybits.Deferred();
        var url = App.cfg.PIXELHOST + '/transform';
        var uploadURL = IMGHOST + '/upload';

        var payload = App.util.Obj.extend(styleState.toJSON(),{
          image: src,
          proxyTarget: uploadURL,
          proxyFileParam: 'file',
          proxyHeaders: {
            'X-Authorization': Flybits.Session.userToken
          },
          proxyParams: {
            isPrivate: false
          }
        });

        Flybits.util.Api.fetch(url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          respType: 'json',
          body: JSON.stringify(payload)
        }).then(function(resp){
          def.resolve(resp.body);
        }).catch(function(e){
          def.reject(e);
        });

        return def.promise;
      }
    };
  })();

  var PixelPusher = (function(){
    function PixelPusher(opts){
      opts = opts || {};
      this.image = opts.image;
      this.$el = opts.$el;
      this.state = ImageFile.StyleState.copy(opts.image.style);
      this.backHistory = [];
      this.forwardHistory = [];
      this.cropper;
      this.constraints = opts.constraints;

      this.commit();
    }
    PixelPusher.prototype.undo = function(){
      if(this.backHistory.length > 1){
        var lastState = this.backHistory.pop();
        this.forwardHistory.unshift(lastState);
        this.revert();
      }
      return this;
    };
    PixelPusher.prototype.redo = function(){
      if(this.forwardHistory.length){
        var futureState = this.forwardHistory.shift();
        this.state.fromJSON(futureState.toJSON());
        this.backHistory.push(futureState);
      }
      return this;
    };
    PixelPusher.prototype.commit = function(noApply){
      var newState = ImageFile.StyleState.copy(this.state);
      this.backHistory.push(newState);
      this.flushForwardHistory();
    };
    PixelPusher.prototype.revert = function(){
      var lastState = this.backHistory[this.backHistory.length -1];
      if(lastState){
        this.state.fromJSON(lastState.toJSON());
      }
    };
    PixelPusher.prototype.flushForwardHistory = function(){
      this.forwardHistory.splice(0,this.forwardHistory.length);
    };
    PixelPusher.prototype.updateImage = function(){
      var filterStr = '';
      var transformStr = '';
      var clipPathStr = '';

      if(this.state.grayscale){
        filterStr += 'grayscale(100%)';
      }
      
      if(+this.state.blur > 0){
        filterStr += 'blur('+((+this.state.blur)*5+0.3)+'px)';
      }

      if(+this.state.rotate > 0 && +this.state.rotate < 360){
        transformStr += 'rotate('+this.state.rotate+'deg)';
      }

      if(this.state.crop){
        var containerData = this.state.crop.containerData;
        var cropBoxData = this.state.crop.cropBoxData;
        var leftX = cropBoxData.left;
        var topY = cropBoxData.top;
        var bottomY = containerData.height - (topY + cropBoxData.height);
        var rightX = containerData.width - (leftX + cropBoxData.width);
        if (bottomY < 0) {
          bottomY = 0;
        }
        if (rightX < 0) {
          rightX = 0;
        }
        clipPathStr += 'inset('+topY+'px '+rightX+'px '+bottomY+'px '+leftX+'px)';

        var offsetX = (containerData.width - cropBoxData.width)/2 - leftX;
        var offsetY = (containerData.height - cropBoxData.height)/2 - topY;
        transformStr += 'translate3d('+offsetX+'px,'+offsetY+'px,0)';
      }

      var retStr = '';
      if(filterStr !== ''){
        retStr += 'filter:'+filterStr+';';
      }
      if(transformStr !== ''){
        retStr += 'transform:'+transformStr+';';
      }
      if(clipPathStr !== ''){
        retStr += 'clip-path:'+clipPathStr+';';
      }


      this.$el.setAttribute('style',retStr);
    };
    PixelPusher.prototype.push = function(){
      var def = new Flybits.Deferred();
      UploadManager.transform(this.image.url,this.state).then(function(obj){
        def.resolve(new ImageFile(obj[0]));
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    };
    PixelPusher.prototype.startCrop = function(){
      var pusher = this;
      // @todo start loading for async image canvas load;
      var cropperOpt = {
        viewMode: 1,
        zommable: false,
        ready: function(){
          // @todo stop loading
        },
        crop: function(e){
          pusher.state.crop = {
            x: e.detail.x,
            y: e.detail.y,
            dx: e.detail.width,
            dy: e.detail.height,
            canvasData: cropper.getCanvasData(),
            cropBoxData: cropper.getCropBoxData(),
            containerData: cropper.getContainerData()
          };
        }
      };

      if(pusher.constraints && pusher.constraints.aspectRatio){
        cropperOpt.aspectRatio = pusher.constraints.aspectRatio;
      }

      var cropper = this.cropper = new window.Cropper(this.$el, cropperOpt);
    };
    PixelPusher.prototype.stopCrop = function(){
      if(this.cropper){
        this.cropper.destroy();
        this.cropper = null;
      }
    };

    return PixelPusher;
  })();

  return Vue.extend({
    template:'#image-manager',
    data: function(){
      return {
        isOpen: false,
        deferredChild: null,
        isEdit: false,
        isDetail: false,
        store: new ImageStore(),
        currentImg: null,
        isLoading: false,
        urlToUpload: null,
        pixelPusher: null,
        detailMode: null,
        constraints: null
      };
    },
    computed: {
      detailChange: function(){
        if(this.pixelPusher){
          var cropStr = JSON.stringify(this.pixelPusher.state.crop);
          return ""+this.pixelPusher.state.blur + this.pixelPusher.state.rotate + this.pixelPusher.state.grayscale + cropStr;
        }

        return false;
      },
    },
    watch: {
      detailChange: function(newVal, oldVal){
        if(newVal && oldVal){
          this.pixelPusher.updateImage();
        }
      },
      detailMode: function(newVal, oldVal){
        if(newVal === 'crop'){
          this.pixelPusher.startCrop();
        } else if(this.pixelPusher){
          this.pixelPusher.stopCrop();
        }
      }
    },
    methods: {
      switchMode: function(mode){
        var view = this;
        this.isEdit = mode && mode.toLowerCase() === 'edit';
        if(this.isEdit && this.currentImg){
          this.pixelPusher = new PixelPusher({
            image: view.currentImg,
            constraints: view.constraints
          });
          Vue.nextTick(function(){
            view.pixelPusher.$el = view.$refs.imageEl;
          });
        }
      },
      pushMode: function(mode){
        this.isDetail = !!mode;
        this.detailMode = mode;
      },
      undo: function(){
        this.pixelPusher.undo();
      },
      redo: function(){
        this.pixelPusher.redo();
      },
      acceptDetail: function(){
        this.isDetail = false;
        this.detailMode = null;
        this.pixelPusher.commit();
      },
      cancelDetail: function(){
        this.isDetail = false;
        this.detailMode = null;
        this.pixelPusher.revert();
      },
      finalizeEdit: function(){
        var view = this;
        this.pixelPusher.push().then(function(imgFile){
          view.store.insertImage(imgFile);
          view.selectImg(imgFile);
          view.switchMode('');
        }).catch(function(e){
          console.log('> uh oh', e);
        });
      },
      deleteFile: function(){
        var view = this;
        if(!this.currentImg){
          return;
        }

        this.isLoading = true;
        this.store.deleteImage(this.currentImg).then(function(){
          view.selectImg(null);
        }).catch(function(e){
          console.log('> uh oh', e);
        }).then(function(){
          view.isLoading = false;
        });
      },
      uploadFile: function(){
        var view = this;

        UploadManager.uploadFile({
          onfilechange: function(){
            view.isLoading = true;
          }
        }).then(function(obj){
          console.log('> fileuplaoded',obj);
          var newImg = new ImageFile(obj[0]);
          view.store.insertImage(newImg);
          view.selectImg(newImg);
        }).catch(function(e){
          console.log('> uh oh', e);
        }).then(function(){
          view.isLoading = false;
        });
      },
      uploadURL: function(){
        var view = this;
        if(!this.urlToUpload){
          return;
        }

        this.isLoading = true;
        UploadManager.uploadURL({
          url: this.urlToUpload
        }).then(function(obj){
          console.log('> urluplaoded',obj);
          view.selectImg(new ImageFile(obj[0]));
          view.urlToUpload = null;
        }).catch(function(e){
          console.log('> uh oh', e);
        }).then(function(){
          view.isLoading = false;
        });
      },
      openManager: function(payload){
        this.isOpen = true;
        this.deferredChild = payload.deferredChild;
        if(payload.existingURL){
          this.selectImg(new ImageFile({
            url: payload.existingURL
          }));
        }
        if(payload.constraints){
          this.constraints = payload.constraints;
        }
      },
      closeManager: function(isCancel){
        var view = this;
        this.isOpen = false;
        if(this.deferredChild){
          if(isCancel){
            this.deferredChild.reject();
          } else{
            this.deferredChild.resolve(this.currentImg);
          }
          this.deferredChild = null;
        }
        setTimeout(function(){
          if(view.pixelPusher){
            view.pixelPusher.stopCrop();
            view.pixelPusher = null;
          }
          view.currentImg = null;
          view.urlToUpload = null;
          view.isEdit = false;
          view.isDetail = false;
          view.detailMode = null;
        }, 200);
      },
      revertEditMode: function(){
        if(this.pixelPusher){
          this.pixelPusher.stopCrop();
          this.pixelPusher = null;
        }
        this.isDetail = false;
        this.detailMode = null;
        this.isEdit = false;
      },
      cancelMode: function(){
        if(this.isEdit){
          this.revertEditMode();
        } else{
          this.closeManager(true);
        }
      },
      completeManage: function(){
        // @TODO validation
        this.closeManager();
      },
      selectImg: function(imgObj){
        this.currentImg = imgObj;
        // @todo apply default contraint editing
      },
      listLoad: function(){
        var view = this;
        var list = this.$refs.imagelist;
        var wrap = this.$refs.imageswrap;
        window.requestAnimationFrame(function(){
          if(list.scrollTop + list.offsetHeight >= (wrap.offsetHeight - 25) && !view.store.isLoading && view.store.hasMore()){
            console.log("> load moar");
            view.store.getMore();
          }
        });
      }
    },
    mounted: function(){
      var view = this;
      setTimeout(function(){
        App.ready.then(function(){
          IMGHOST = App.cfg.HOST + '/kernel/file-manager/files';
          Flybits.Session.ready.then(function(){
            view.store.getMore();
          });
          App.evt.on(App.actions.OPENMANAGEIMAGE, function(payload){
            view.openManager(payload)
          });
        });
      },1);
    }
  });
})();
Vue.component('image-manager',ImageManager);

var ImageField = Vue.extend({
  template:'#image-field',
  props: {
    value: String,
    aspectRatio: String,
    editable: {
      type: Boolean,
      default: true
    }
  },
  data: function(){
    return {
      currentURL: null
    };
  },
  watch: {
    value: function(newVal, oldVal){
      this.currentURL = newVal;
    }
  },
  methods: {
    openManager: function(){
      if(!this.editable){
        return;
      }
      var view = this;
      var deferredChild = new Flybits.Deferred();
      var managePayload = {
        deferredChild: deferredChild
      };
      if(this.currentURL){
        managePayload.existingURL = this.currentURL;
      }
      if(this.aspectRatio){
        var w = +this.aspectRatio.split('/')[0];
        var h = +this.aspectRatio.split('/')[1];
        managePayload.constraints = {
          aspectRatio: +(w/h).toFixed(4)
        };
      }
      
      deferredChild.promise.then(function(imgFile){
        view.setImg(imgFile);
        console.log('> manager closed');
      }).catch(function(){
        console.log('> manager error closed');
      });
      App.evt.emit(App.actions.OPENMANAGEIMAGE, managePayload);
    },
    setImg: function(imageFile){
      if(!imageFile){
        return;
      }

      this.currentURL = imageFile.url;
      this.$emit('input',imageFile.url);
    }
  },
  mounted: function(){
    this.currentURL = this.value;
  }
});
Vue.component('image-field',ImageField);

var ToggleView = Vue.extend({
  template:'#toggle-view',
  props:['value','label','inverted'],
  methods:{
    toggle:function(){
      this.$emit('input',!this.value);
    }
  }
});
Vue.component('toggle-view',ToggleView);
var ConditionalModal = Vue.extend({
  template:'#conditional-modal',
});
Vue.component('conditional-modal',ConditionalModal);

var ContextPicker = Vue.extend({
  template:'#context-picker',
  props: {
    plugins: Array
  },
  data: function(){
    return {
      isOpen: false,
      tmpCTX: 'none',
      deferredPromise: null,
      isTmpNew: true,
    };
  },
  computed: {
    selectedIcon: function(){
      return this.tmpCTX !== 'none'?this.tmpCTX.iconURL:'';
    }
  },
  methods: {
    closePicker: function(bool){
      this.isOpen = false;
      this.tmpCTX = 'none';
      this.plugins.forEach(function(plugin){
        plugin.clearValues();
      });
      if(this.deferredPromise){
        this.deferredPromise.resolve();
      }
    },
    openPicker: function(ctx){
      this.isOpen = true;
      if(ctx){
        this.tmpCTX = ctx;
      }
    },
    saveChanges: function(){
      var ctxValues = this.tmpCTX.getValues();
      console.log('> oh', ctxValues);
      if(this.deferredPromise){
        this.deferredPromise.resolve(ctxValues);
        this.deferredPromise = null;
      }
      this.closePicker();
    }
  },
  mounted: function(){
    var view = this;
    App.ready.then(function(){
      App.evt.on(App.actions.OPENCTXPICKER, function(payload){
        payload = payload || {};
        view.deferredPromise = payload.deferredPromise;
        if(payload.value && payload.value instanceof CtxValues){
          payload.value.ctx.setValues(payload.value);
          view.tmpCTX = payload.value.ctx;
          view.isTmpNew = false;
        } else{
          view.isTmpNew = true;
        }
        view.openPicker(payload.ctx);
      });
    });
  }
});
Vue.component('context-picker',ContextPicker);

var FieldTypeEditor = Vue.extend({
  template:'#field-type-editor',
  props: {
    value: Object // attribute
  },
  data: function(){
    return {
      tmp: {}
    };
  },
  computed: {
    type: function(){
      return this.value?this.value.type:null;
    }
  },
  watch: {
    tmp: {
      deep: true,
      handler: function(newVal, oldVal){
        var keys = Object.keys(this.tmp);
        var tmpObj = this.tmp;
        var values = keys.map(function(key){
          return tmpObj[key];
        }).filter(function(obj){
          return obj !== undefined && obj !== null;
        });
        this.value._input = values.join(',');
      }
    }
  },
});
Vue.component('field-type-editor',FieldTypeEditor);

var CtxvalueList = Vue.extend({
  template:'#ctxvalue-list',
  props: {
    ctxs: Array,
    editable: {
      default: true,
      type: Boolean
    }
  },
  methods: {
    getValues: function(ctxValues){
      return Object.keys(ctxValues.values).map(function(key){
        return {
          key: key,
          value: ctxValues.values[key]
        };
      });
    },
    emitEdit: function(ctxVal){
      this.$emit('edit',ctxVal);
    },
    emitDelete: function(ctxVal){
      this.$emit('delete',ctxVal);
    }
  }
});
Vue.component('ctxvalue-list',CtxvalueList);

var ProfileList = Vue.extend({
  template:'#profile-list',
  props: {
    list: {
      default: function(){
        return [];
      },
      type: Array
    }
  },
  data: function(){
    return {
      profileDelete: null,
    }
  },
  methods: {
    confirmDelete: function(profile){
      this.profileDelete = profile;
    },   
    cancelDelete: function(){
      this.profileDelete = null;
    },
    emitEdit: function(profile){
      this.$emit('edit', profile);
    },
    emitDelete: function(){
      if(this.profileDelete){
        this.$emit('delete', this.profileDelete);
      }
      this.cancelDelete();
    },
    emitMoveUp: function(profile){
      this.$emit('moveup', profile);
    },
    emitMoveDown: function(profile){
      this.$emit('movedown', profile);
    },
    updateVisibility: function(profile){
      this.$emit('update', profile);
    }
  }
});
Vue.component('profile-list',ProfileList);

var QrField = (function(){
  return Vue.extend({
    template:'#qr-field',
    props: ['text'],
    watch: {
      text: function(newVal, oldVal){
        this.generate();
      }
    },
    methods: {
      generate: function(){
        if(this.text){
          this.$refs.qr.innerHTML = '';
          new QRCode(this.$refs.qr,{
            text: this.text,
            colorLight: '#1162A4',
            colorDark: '#ffffff'
          })
        } else{
          this.$refs.qr.innerHTML = '';
        }
      }
    },
    mounted: function(){
      this.generate();
    }
  });
})();
Vue.component('qr-field',QrField);

var BaseRoute = (function(){
  function BaseRoute(opts){
    opts = opts || {};
    if(opts.beforeRouteEnter){
      this.extBeforeRouteEnter = opts.beforeRouteEnter;
      delete opts.beforeRouteEnter;
    }
    Flybits.util.Obj.extend(this, opts,{
      mutate: true
    });
  };
  
  BaseRoute.prototype = {
    beforeRouteEnter: function(to, from, next){
      var route = to.matched[0]?to.matched[0].components.default:null;
      setTimeout(function(){
        App.ready.then(function(){
          if(route && route.extBeforeRouteEnter){
            route.extBeforeRouteEnter(to, from, next);
          } else{
            next();
          }
        });
      },1);
    }
  };
  
  return BaseRoute;
})();
var AuthenticatedRoute = (function(){
  function AuthenticatedRoute(opts){
    BaseRoute.call(this, opts);
  }

  AuthenticatedRoute.prototype = Object.create( BaseRoute.prototype );
  AuthenticatedRoute.prototype.constructor = AuthenticatedRoute;

  AuthenticatedRoute.prototype.beforeRouteEnter = function(to, from, next){
    var route = to.matched[0]?to.matched[0].components.default:null;
    setTimeout(function(){
      App.ready.then(function(){
        Flybits.Session.resolveSession().then(function(){
          if(route && route.extBeforeRouteEnter){
            route.extBeforeRouteEnter(to, from, next);
          } else{
            next();
          }
        }).catch(function(e){
          Flybits.Session.clearSession();
          App.authClient.request();          
        });
      });
    },1);
  };

  return AuthenticatedRoute;
})();
var SplashPage = (function(){

  return {
    template: '#splash-page',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        App.ready.then(function(){
          App.router.replace('journey');
        });
      });
    }
  };

})();
Vue.component('splash-page',SplashPage);
var Landscape = (function(){

  return new BaseRoute({
    template:'#landscape',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        if(App.cfg.defaultWindowCount){
          for(var i = 0; i < App.cfg.defaultWindowCount; i++){
            vm.addWindow();
          }
        }
      });
    },
    data: function(){
      return {
        windows: [],
      };
    },
    methods: {
      addWindow: function(){
        var view = this;
        var newWindow = new AppWindow({
          container: this.$el,
          url: App.cfg.APPHOST,
          onclosed: function(){
            App.util.Obj.removeObject(view.windows,newWindow,function(obj){
              return obj.tmpID === newWindow.tmpID;
            });
          }
        }).create();

        this.windows.push(newWindow);
      },
      config: function(){
        App.router.push('configure');
      },
      showLink: function(){
        App.router.push('onboard');
      },
      gotoPhoneView: function(){
        App.router.push('journey');
      }
    }
  });

})();
Vue.component('landscape',Landscape);
var Configure = (function(){

  var THEMEMODE = 1;
  var PROFILEMODE = 2;
  var SUMMARYMODE = 3;

  return new AuthenticatedRoute({
    template:'#configure',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        vm.init();
        vm.version = App.version;
      });
    },
    data: function(){
      return {
        curMode: SUMMARYMODE,
        project: null,
        theme: null,
        themes: null,
        profiles: null,
        themeToggle: null,
        profileToggle: null,
        version: ''
      };
    },
    computed: {
      panelMode: function(){
        if(this.curMode === SUMMARYMODE){
          return '';
        }

        return this.curMode === THEMEMODE?'theme':'profile';
      },
      isWidget: function(){
        return this.theme && this.theme.mode === 'widget';
      },
      isFullscreen: function(){
        return this.theme && this.theme.mode === 'fullscreen';
      },
      isEmbedded: function(){
        return this.theme && this.theme.mode === 'embedded';
      }
    },
    watch: {
      curMode: function(newVal, oldVal){
        if(newVal === THEMEMODE){
          this.engageToggle(this.themeToggle);
          this.disengageToggle(this.profileToggle, true);
        } else if(newVal === PROFILEMODE){
          this.engageToggle(this.profileToggle);
          this.disengageToggle(this.themeToggle, true);
        } else{
          this.disengageToggle(this.themeToggle);
          this.disengageToggle(this.profileToggle);
        }
      }
    },
    methods: {
      init: function(){
        var view = this;
        this.initModeToggles();
        App.store.getProject().then(function(proj){
          view.project = proj;
        }).then(function(){
          return App.store.getProfiles(view.project.ctxPlugins);
        }).then(function(profiles){
          view.profiles = profiles;
        }).catch(function(e){
          var def = new Flybits.Deferred();
          view.theme = null;
          view.themes = null;
          Flybits.Session.disconnect();
          App.toast('Invalid user permissions.');
          App.evt.emit(App.actions.PROMPTLOGIN,{
            isOpen: true,
            deferred: def
          });
          def.promise.then(function(){
            App.evt.emit(App.actions.PROMPTLOGIN,{
              isOpen: false
            });
            view.init();
          });
        });

        App.store.getTheme().then(function(theme){
          view.theme = theme;
        }).catch(function(e){
          console.log('> uh oh', e);
        });

        App.store.getThemes().then(function(themes){
          view.themes = themes;
        }).catch(function(e){
          console.log('> uh oh', e);
        });
      },
      initModeToggles: function(){
        var bounds = this.themeToggle.getBoundingClientRect();
        this.themeToggle.style.top = bounds.y+'px';
        this.themeToggle.style.left = bounds.x+'px';
        
        bounds = this.profileToggle.getBoundingClientRect();
        this.profileToggle.style.top = bounds.y+'px';
        this.profileToggle.style.right = (bounds.x - 105)+'px';
        
        this.themeToggle.style.position = 'fixed';
        this.profileToggle.style.position = 'fixed';

        this.themeToggle.setAttribute('data-style',this.themeToggle.getAttribute('style'));
        this.profileToggle.setAttribute('data-style',this.profileToggle.getAttribute('style'));
      },
      switchMode: function(mode){
        if(mode === this.curMode){
          this.curMode = SUMMARYMODE;
        } else {
          this.curMode = mode;
        }
      },
      engageToggle: function(toggle){
        toggle.classList.add('last');
        toggle.setAttribute('data-style',toggle.getAttribute('style'));
        toggle.removeAttribute('style');
        toggle.classList.remove('inactive');
      },
      disengageToggle: function(toggle, showInactive){
        toggle.setAttribute('style',toggle.getAttribute('data-style'));
        toggle.classList.remove('last');

        if(showInactive){
          toggle.classList.add('inactive');
        } else{
          toggle.classList.remove('inactive');
        }
      },
      logout: function(){
        Flybits.Session.clearSession();
        App.router.replace('landscape');
        App.toast('Successfully logged out');
      }
    },
    mounted: function(){
      this.themeToggle = this.$el.querySelector('.mode-icon.theme');
      this.profileToggle = this.$el.querySelector('.mode-icon.profile');
    }
  });

})();
Vue.component('configure',Configure);
var LinkShow = (function(){

  return {
    template:'#link-show',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        vm.init();
      });
    },
    data: function(){
      return {
        url: '',
        host: '',
      };
    },
    methods: {
      init: function(){
        this.host = window.location.host;
        this.url = 'https://'+this.host;
        new QRCode(this.$refs.qr,{
          text: this.url,
          colorLight: '#1162A4',
          colorDark: '#ffffff'
        });
      },
      goback: function(){
        App.router.back();
      }
    }
  };

})();
Vue.component('link-show',LinkShow);
var AuthCallback = (function(){

  return new BaseRoute({
    template:'#auth-callback',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        App.evt.emit(App.actions.LOADING, true);
        App.authClient.requestSPAuthz().then(function(res){
          if(res && res.accessToken){
            Flybits.Session.setUserToken(res.accessToken);
            App.router.replace('configure');
          } else{
            App.router.replace('landscape');
            console.log('> uh oh: no valid accessToken')
            App.toast('Authorization denied','error');
          }
        }).catch(function(e){
          console.log('> blah', e);
          App.router.replace('landscape');
          App.toast('Authorization denied','error');
        }).then(function(){
          App.evt.emit(App.actions.LOADING, false);
        });
      });
    }
  });

})();
Vue.component('auth-callback',AuthCallback);
var Journey = (function(){
  const SAREPORTURL = 'https://api.demo.flybits.com/context/ctxdata/sa';
  const REPORTURL = 'https://api.demo.flybits.com/context/ctxdata';

  var reportReset = function(){
    return Flybits.util.Api.flbFetch(REPORTURL, {
      method: 'POST',
      respType: 'none',
      body: JSON.stringify([
        {
          "dataTypeID": "ctx.mybank.CheckingAccountTransactions",
          "value": {
            "Deposit-Amount": 0
          }
        }
        // {
        //   "email": "1234",
        //   "dataTypeID": "ctx.td-demo1.td-customer-profile",
        //   "value": {
        //     "segment": "x"
        //   }
        // },
        // {
        //   "email": "1234",
        //   "dataTypeID": "ctx.td-demo1.td-product-eligibility",
        //   "value": {
        //     "product-type": "x"
        //   }
        // },
        // {
        //   "email": "1234",
        //   "dataTypeID": "ctx.td-demo1.adobe-experience-manager",
        //   "value": {
        //     "content-engagement": "x"
        //   }
        // },
        // {
        //   "email": "justin1",
        //   "dataTypeID": "ctx.td-demo1.adobe-audience-manager",
        //   "value": {
        //     "custom-segment": "x"
        //   }
        // },
        // {
        //   "email": "petar1",
        //   "dataTypeID": "ctx.td-demo1.td-customer-profile",
        //   "value": {
        //     "segment": "x"
        //   }
        // },
        // {
        //   "email": "petar1",
        //   "dataTypeID": "ctx.td-demo1.td-product-eligibility",
        //   "value": {
        //     "product-type": "x"
        //   }
        // },
        // {
        //   "email": "petar1",
        //   "dataTypeID": "ctx.td-demo1.adobe-experience-manager",
        //   "value": {
        //     "content-engagement": "x"
        //   }
        // },
        // {
        //   "email": "petar1",
        //   "dataTypeID": "ctx.td-demo1.adobe-audience-manager",
        //   "value": {
        //     "custom-segment": "x"
        //   }
        // }
      ])
    })
  };
  var report1 = function(){
    return Flybits.util.Api.flbFetch(REPORTURL, {
      method: 'POST',
      respType: 'none',
      body: JSON.stringify([
        {
          "dataTypeID": "ctx.mybank.CheckingAccountTransactions",
          "value": {
            "Deposit-Amount": 6000
          }
        },
      ])
    })
  };
  // var report1 = function(){
  //   return Flybits.util.Api.fetch(SAREPORTURL, {
  //     method: 'POST',
  //     respType: 'none',
  //     headers: {
  //       'x-authorization': SAJWT,
  //       'content-type': 'application/json'
  //     },
  //     body: JSON.stringify([
  //       {
  //         "email": "justin1",
  //         "dataTypeID": "ctx.td-demo1.td-customer-profile",
  //         "value": {
  //           "segment": "Student"
  //         }
  //       },
  //       {
  //         "email": "justin1",
  //         "dataTypeID": "ctx.td-demo1.td-product-eligibility",
  //         "value": {
  //           "product-type": "Credit Card"
  //         }
  //       },
  //       {
  //         "email": "petar1",
  //         "dataTypeID": "ctx.td-demo1.td-customer-profile",
  //         "value": {
  //           "segment": "Student"
  //         }
  //       },
  //       {
  //         "email": "petar1",
  //         "dataTypeID": "ctx.td-demo1.td-product-eligibility",
  //         "value": {
  //           "product-type": "Credit Card"
  //         }
  //       }
  //     ])
  //   })
  // };

  var Layout = {
    LAYING: 'laying',
    FRONT: 'front',
    SIDE: 'side'
  }

  var reportC5CTX = function(ctxPayload){
    var url = 'https://api.demo.flybits.com/context/ctxdata';
    return Flybits.util.Api.flbFetch(url,{
      method: 'POST',
      body: JSON.stringify(ctxPayload),
      respType: 'none'
    });
  };

  var authOIDC = function(authObj){
    var idp = new OidcIDP({
      projectID: App.cfg.PROJECTID,
      idToken: authObj.token
    });
    return Flybits.Session.connect(idp);
  };

  var authOkta = function(authObj){
    var idp = new Flybits.idp.OAuthIDP({
      providerName: 'okta',
      projectID: App.cfg.PROJECTID,
      accessToken: authObj.token
    });
    return Flybits.Session.connect(idp);
  };

  var authJWT = function(authObj){
    Flybits.Session.setUserToken(authObj.token);
    return Flybits.api.User.getSignedInUser();
  };

  var authFlybitsIDP = function(authObj){
    var idp = new Flybits.idp.FlybitsIDP({
      email: authObj.ref,
      password: authObj.token,
      projectID: App.cfg.PROJECTID
    });
    return Flybits.Session.connect(idp);
  };

  var authAnonymous = function(authObj){
    var idp = new Flybits.idp.AnonymousIDP({
      projectID: App.cfg.PROJECTID
    });
    return Flybits.Session.connect(idp);
  };

  var authAPIKey = function(authObj){
    var idp = new Flybits.idp.ApiKeyIDP({
      email: authObj.email,
      apiKey: authObj.apiKey,
      projectID: authObj.projectID
    });
    return Flybits.Session.connect(idp);
  };

  return new BaseRoute({
    template:'#journey',
    beforeRouteEnter: function(to, from, next){
      next(function(vm){
        vm.init();
      });
    },
    beforeRouteLeave: function(to, from, next){
      // @TODO only add if you want to initProfile
      // Flybits.Session.clearSession();
      next();
    },
    data: function(){
      return {
        mode: Layout.LAYING,
        isQRVisible: false,
        isIframeLoading: false,
        isLoadingData: false,
        isPhoneLoading: false,
        isOverlayOpen: false,
        startLoadTime: 0,
        endLoadTime: 0,
        appURL: '',
        linkURL: '',
        modeBannerURL: '',
        travelMode: false,
        modeLabel: '',
        currentStep: 'start',
        profile: null,
        iframeLoadPromise: null,
        nav: null,
        phoneWidth: -1,
        phoneHeight: -1,
        journey: [
          {
            key: 'start',
            label: 'Start',
            icon: 'images/off.png',
            showLabel: false,
            action: function(){
              this.travelMode = false;
              this.mode = Layout.LAYING;
              this.appURL = '';
              this.modeBannerURL = '';
              this.modeLabel = '';
              this.iframeLoadPromise = null;
              this.closeOverlay();
              this.nav.stopPoll();
              reportReset();
            },
          },{
            key: 'boot',
            label: 'Launch App',
            icon: 'images/on.png',
            showLabel: true,
            action: function(){
              var vm = this;
              var iframeLoadDeferred = new Flybits.Deferred();
              this.iframeLoadPromise = iframeLoadDeferred.promise;
              this.mode = Layout.FRONT;
              
              var loadCallback = function(){
                console.log('> iframe loaded');
                iframeLoadDeferred.resolve();
              };
              this.$refs.frame.addEventListener('load', loadCallback);
              this.iframeLoadPromise.then(function(){
                vm.$refs.frame.removeEventListener('load',loadCallback);
              });
              this.startLoad();
              Vue.nextTick(function(){
                vm.appURL = App.cfg.APPHOST;
              });

              authAnonymous({
                projectID: App.cfg.PROJECTID
              }).then(function(){
                return vm.nav.push(NavStack.CONCIERGE,{
                  zoneRef: App.cfg.HOMEZONEREF || 'homepage',
                  skipCache: true,
                  noLoader: true
                });
              }).catch(function(e){}).then(function(){
                setTimeout(function(){
                  vm.endLoad();
                }, 300);
              });
            },
          },{
            key: 'reload',
            label: 'Reload',
            icon: 'images/refresh.png',
            showLabel: true,
            stateUnselectable: true,
            action: function(){
              this.nav.reload().then(function(){
                App.toast('Updated');
              })
            }
          },
        ]
      }
    },
    computed: {
      isPolling: function(){
        return this.nav && this.nav.isPolling;
      },
      isMobile: function(){
        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
      },
      loadingLogo: function(){
        return  App.cfg.themeDefaults.loadingIconURL || 'images/tdlogo.png';
      }
    },
    watch: {
      phoneWidth: function(newVal, oldVal){
        if(oldVal && newVal){
          this.$refs.phone.style.width = newVal + 'px';
        }
      },
      phoneHeight: function(newVal, oldVal){
        if(oldVal && newVal){
          this.$refs.phone.style.height = newVal + 'px';
        }
      }
    },
    methods: {
      init: function(){
        var view = this;
        App.evt.on(App.actions.FRAMELOADING, function(val){
          if(val){
            view.startLoad();
          } else{
            view.endLoad();
          }
        });
        this.nav = App.nav = new NavStack(this);
      },
      initProfile: function(){
        var promise = Promise.resolve();
        this.profile = App.store.profiles?App.store.profiles.list.filter(function(profile){
          return profile.description === 'comms;roaming';
        })[0]:null;

        if(!this.profile){
          App.toast('Missing profile: comms;roaming', 'error')
        }

        if(this.profile.authType === Profile.auth.OIDC){
          promise = authOIDC(this.profile.auth);
        } else if(this.profile.authType === Profile.auth.OKTA){
          promise = authOkta(this.profile.auth);
        } else if(this.profile.authType === Profile.auth.JWT){
          promise = authJWT(this.profile.auth);
        } else if(this.profile.authType === Profile.auth.FLYBITS){
          promise = authFlybitsIDP(this.profile.auth);
        } else if(this.profile.authType === Profile.auth.ANONYMOUS){
          promise = authAnonymous(this.profile.auth);
        } 

        return promise;
      },
      switchLayout: function(mode){
        this.mode = mode;
      },
      isCurrent: function(step){
        return step.key === this.currentStep;
      },
      selectStep: function(step){
        if(!step.stateUnselectable){
          this.currentStep = step.key;
        }
        if(step.action){
          step.action.call(this);
        }
      },
      togglePolling: function(){
        this.nav.togglePolling();
      },
      toggleQR: function(){
        this.isQRVisible = !this.isQRVisible;
      },
      reportTrue: function(){
      },
      reportFalse: function(){
      },
      gotoConfigure: function(){
        App.router.push('configure');
      },
      gotoDashboard: function(){
        App.router.push('landscape');
      },
      startLoad: function(){
        this.startLoadTime = Date.now();
        this.isLoadingData = true;
      },
      endLoad: function(){
        if(this.isLoadingData){
          this.endLoadTime = Date.now();
          var diff = this.endLoadTime - this.startLoadTime;
          var delay = diff < 200?200-diff:0;
          var view = this;
          setTimeout(function(){
            view.isLoadingData = false;
          }, delay);
        }
      },
      inject: function(zone){
        var frame = this.$refs.frame;
        if(this.iframeLoadPromise){
          this.iframeLoadPromise.then(function(){
            frame.contentWindow.postMessage(zone, '*');
          });
        } else{
          frame.contentWindow.postMessage(zone, '*');
        }
      },
      injectOverlay: function(zone){
        const view = this;
        var frame = this.$refs.overlay;
        this.isOverlayOpen = true;
        view.isPhoneLoading = true;
        var loadCallback = function(){
          console.log('> iframe loaded');
          frame.contentWindow.postMessage(zone, '*');
          frame.removeEventListener('load', loadCallback);
          view.isPhoneLoading = false;
        };
        frame.addEventListener('load', loadCallback);
        frame.setAttribute('src', App.cfg.APPHOST);
      },
      closeOverlay: function(){
        this.isOverlayOpen = false;
        this.$refs.overlay.removeAttribute('src');
      },
      openInternalBrowser: function(url){
        this.linkURL = url;
      },
      handleAction: function(eventObj){
        var actionLink = eventObj.actionlink;
        if(!actionLink){
          return;
        }

        if(actionLink.startsWith('concierge://')){
          var zoneRef = App.util.Browser.getURLParam('zoneReferenceId', actionLink);
          var overlayParam = Boolean(App.util.Browser.getURLParam('overlay', actionLink));
          this.nav.push(NavStack.CONCIERGE,{
            zoneRef: zoneRef,
            skipCache: true,
            overlay: overlayParam
          })
        } else if(actionLink.startsWith('details://')){
          var contentInfo = eventObj.contentInfo;
          var contentIdParam = App.util.Browser.getURLParam('contentId', actionLink);
          var pageTitleParam = App.util.Browser.getURLParam('title', actionLink);
          var overlayParam = Boolean(App.util.Browser.getURLParam('overlay', actionLink));
          if(contentIdParam){
            this.nav.push(NavStack.DETAILS,{
              contentID: contentIdParam,
              pageTitle: pageTitleParam,
              skipCache: true,
              overlay: overlayParam
            })
          } else if(contentInfo && contentInfo.id){
            this.nav.push(NavStack.DETAILS,{
              contentID: contentInfo.id,
              pageTitle: pageTitleParam,
              overlay: overlayParam
            });
          } else{
            console.log('> no valid content info');
          }
        } else if(actionLink.startsWith('browser://')){
          // external browser
          var urlParam = App.util.Browser.getURLParam('url', actionLink);
          if(urlParam){
            window.open(urlParam, '_blank');
          }
        } else if(actionLink.startsWith('https://')){
          window.open(actionLink, '_blank');
        } else if(actionLink.startsWith('web://')){
          // in app browser
          var urlParam = App.util.Browser.getURLParam('url', actionLink);
          if(urlParam){
            this.openInternalBrowser(urlParam);
          }
        } else if(actionLink.startsWith('back://')){
          this.nav.back();
        } else{
          console.log('> no supported action');
        }
      },
      handleCtxReport: function(payload){
        if(payload && Array.isArray(payload)){
          payload = payload.map(function(dataObj){
            return {
              dataTypeID: dataObj.pluginId || dataObj.dataTypeID,
              value: dataObj.values || dataObj.value
            };
          });
        }
        reportC5CTX(payload).catch(function(e){
          console.log('> failed to report ctx', e);
        })
      },
      navBack: function(){
        this.nav.back();
      },
      navHome: function(){
        this.nav.push(NavStack.CONCIERGE,{
          zoneRef: App.cfg.HOMEZONEREF || 'homepage',
          skipCache: true,
          noLoader: false
        });
      }
    },
    mounted: function(){
      var vm = this;
      window.addEventListener('message', function(payload){
        try{ // concierge action events are serialized
          if(payload.data && payload.data.flb){
            var eventObj = payload?.data?.value ? JSON.parse(payload.data.value):{};
            if(payload.data.type === 'context'){
              console.log('> ctx report', eventObj)
              vm.handleCtxReport(eventObj);
            } else if(payload.data.type === 'action'){
              vm.handleAction(eventObj);
            } else if(payload.data.type === 'analytics'){
              // @TODO implement analytics
              console.log('> analytics', eventObj);
            } else if(payload.data.type === 'error'){
              // @TODO implement analytics
              console.log('> error', eventObj);
            } else if(payload.data.type === 'dismiss'){
              if(vm.isOverlayOpen){
                vm.nav.back();
              }
            } else{
              // not supported messages  
              console.log('> tada', eventObj)
            }
          } else{
            // non-concierge messages  
          }
        } catch(e){
          // non-concierge messages
          console.log('> cannot parse value', e)
        }
      });
      if(this.isMobile){
        this.selectStep(this.journey[1]);
      }

      this.phoneWidth = Math.round(this.$refs.phone.clientWidth);
      this.phoneHeight = Math.round(this.$refs.phone.clientHeight);
    }
  });

})();
Vue.component('journey',Journey);
var Store = (function(){
  var curSession;

  var getSession = function(){
    var def = new Flybits.Deferred();
    var url = App.cfg.SETTINGSHOST + '/session?key=' + App.cfg.SETTINGSKEY;
    
    Flybits.util.Api.fetch(url,{
      respType: 'json'
    }).then(function(resp){
      def.resolve(resp.body);
    }).catch(function(e){
      def.reject(e);
    });

    return def.promise;
  };

  var Store = {
    theme: null,
    themes: null,
    profiles: null,
    project: null,
    zoneContainers: null,
    init: function(){
      var def = new Flybits.Deferred();
      if(curSession){
        def.resolve();
        return def.promise;
      }

      getSession().then(function(body){
        curSession = body.key;
        return Store.getProfiles();
      }).then(function(){
        def.resolve();
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    },
    resolveGroupName: function(prefix){
      var gName = App.cfg.PROJECTID;
      if(App.cfg.hasOwnProperty('variant')){
        gName += '-'+App.cfg.variant;
      }
      if(prefix){
        gName = prefix + gName;
      }
      return gName;
    },
    getProject: function(){
      var fetchPromise = Api.getProject();
      fetchPromise.then(function(project){
        Store.project = project;
      });

      return fetchPromise;
    },
    upsertTheme: function(theme){
      var def = new Flybits.Deferred();
      var url = App.cfg.SETTINGSHOST + '/model';

      Flybits.util.Api.fetch(url, {
        method: 'POST',
        headers: {
          key: curSession,
          'Content-Type': 'application/json'
        },
        respType: 'none',
        body: JSON.stringify(theme.toJSON())
      }).then(function(resp){
        Store.theme = theme;
        def.resolve(theme);
      }).catch(function(e){
        console.error(e);
        def.reject();
      });

      return def.promise;
    },
    upsertProfiles: function(profiles){
      var def = new Flybits.Deferred();
      var url = App.cfg.SETTINGSHOST + '/model';

      Flybits.util.Api.fetch(url, {
        method: 'POST',
        headers: {
          key: curSession,
          'Content-Type': 'application/json'
        },
        respType: 'none',
        body: JSON.stringify(profiles.toJSON())
      }).then(function(resp){
        Store.profiles = profiles;
        def.resolve(profiles);
      }).catch(function(e){
        console.error(e);
        def.reject();
      });

      return def.promise;
    },
    upsertThemes: function(themes){
      var def = new Flybits.Deferred();
      var url = App.cfg.SETTINGSHOST + '/model';

      Flybits.util.Api.fetch(url, {
        method: 'POST',
        headers: {
          key: curSession,
          'Content-Type': 'application/json'
        },
        respType: 'none',
        body: JSON.stringify(themes.toJSON())
      }).then(function(resp){
        Store.themes = themes;
        def.resolve(themes);
      }).catch(function(e){
        console.error(e);
        def.reject();
      });

      return def.promise;
    },
    getTheme: function(){
      var def = new Flybits.Deferred();
      var groupName = this.resolveGroupName('theme-');
      var url = App.cfg.SETTINGSHOST + '/models?groupName='+groupName;

      Flybits.util.Api.fetch(url, {
        headers: {
          key: curSession
        },
        respType: 'json'
      }).then(function(resp){
        return new Theme(resp.body.data[0], groupName);
      }).catch(function(e){
        if(e.firstError().serverCode === 404){
          var newTheme = new Theme(undefined, groupName);
          return Store.upsertTheme(newTheme);
        }
      }).then(function(theme){
        if(theme){
          Store.theme = theme;
          def.resolve(theme);
        } else{
          def.reject(new Flybits.Validation().addError('cannot retrieve theme','',{
            code: Flybits.Validation.type.RETRIEVALERROR
          }));
        }
      });

      return def.promise;
    },
    getThemes: function(){
      var def = new Flybits.Deferred();
      var groupName = App.cfg.store.themeset;
      var url = App.cfg.SETTINGSHOST + '/models?groupName='+groupName;

      Flybits.util.Api.fetch(url, {
        headers: {
          key: curSession
        },
        respType: 'json'
      }).then(function(resp){
        return new Themes(resp.body.data[0], groupName);
      }).catch(function(e){
        if(e.firstError().serverCode === 404){
          var newThemes = new Themes(undefined, groupName);
          return Store.upsertThemes(newThemes);
        }
      }).then(function(themes){
        if(themes){
          Store.themes = themes;
          def.resolve(themes);
        } else{
          def.reject(new Flybits.Validation().addError('cannot retrieve available themes','',{
            code: Flybits.Validation.type.RETRIEVALERROR
          }));
        }
      });

      return def.promise;
    },
    getProfiles: function(ctxPlugins){
      var def = new Flybits.Deferred();
      var groupName = this.resolveGroupName('profiles-');
      var url = App.cfg.SETTINGSHOST + '/models?groupName=' + groupName;

      Flybits.util.Api.fetch(url, {
        headers: {
          key: curSession
        },
        respType: 'json'
      }).then(function(resp){
        return new Profiles(resp.body.data[0], groupName);
      }).catch(function(e){
        if(e.firstError().serverCode === 404){
          var newProfiles = new Profiles(undefined, groupName);
          return Store.upsertProfiles(newProfiles);
        }
      }).then(function(profiles){
        if(profiles){
          Store.profiles = profiles;
          def.resolve(profiles);
        } else{
          def.reject(new Flybits.Validation().addError('cannot retrieve profiles', '',{
            code: Flybits.Validation.type.RETRIEVALERROR
          }));
        }
      })

      return def.promise;
    },
    getZonesContent: function(opts){
      opts = opts || {};
      var { jwt, zoneRef, zoneLabels } = opts;
      var def = new Flybits.Deferred();
      var url = App.cfg.HOST + '/kernel/experiences/zoneconfigurations/contents';

      var resolvedJWT = jwt || Flybits.Session.userToken;
      Flybits.util.Api.fetch(url, {
        headers: {
          'x-authorization': resolvedJWT,
          'content-type': 'application/json'
        },
        respType: 'json'
      }).then(function(res){
        Store.zoneContainers = new ZoneContainers(res.body);
        def.resolve(Store.zoneContainers.toInjectPayload(zoneRef));
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    },
    getCachedZone: function(zoneRef){
      return Store.zoneContainers?Store.zoneContainers.toInjectPayload(zoneRef):null;
    },
    getCachedDetails: function(contentID, pageTitle){
      return Store.zoneContainers?Store.zoneContainers.toDetailsPayload(contentID, pageTitle):null;
    },
    getDetails: function(contentID, opts){
      opts = opts || {};
      var { jwt } = opts;
      var def = new Flybits.Deferred();
      var url = App.cfg.HOST + '/kernel/content/instances/'+contentID+'?data=true';

      var resolvedJWT = jwt || Flybits.Session.userToken;
      Flybits.util.Api.fetch(url,{
        headers: {
          'x-authorization': resolvedJWT,
          'content-type': 'application/json'
        },
        respType: 'json'
      }).then(function(resp){
        var content = new Flybits.Content(resp.body);
        def.resolve(ZoneContainers.createDetailsPayload(content,opts.pageTitle));
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    },
    getOverlay: function(contentID, opts){
      opts = opts || {};
      var { jwt } = opts;
      var def = new Flybits.Deferred();
      var url = App.cfg.HOST + '/kernel/content/instances/'+contentID+'?data=true';

      var resolvedJWT = jwt || Flybits.Session.userToken;
      Flybits.util.Api.fetch(url,{
        headers: {
          'x-authorization': resolvedJWT,
          'content-type': 'application/json'
        },
        respType: 'json'
      }).then(function(resp){
        var content = new Flybits.Content(resp.body);
        def.resolve(ZoneContainers.createOverlayPayload(content,opts.pageTitle));
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    },
    getCachedOverlay: function(contentID){
      return Store.zoneContainers?Store.zoneContainers.toOverlayPayload(contentID):null;
    }
  };

  return Store;
})();
var App = (function(){
  var deferredReady = new Deferred();

  var App = {
    ready: deferredReady.promise,
    vm: null,
    evt: null,
    version: '',
    ext: {
      CONFIG:"res/config.json",
      VERSION: 'version.txt'
    },
    actions: {
      LOADING: "loading",
      CONFIG_UPDATE: "configupdated",
      PROMPTLOGIN: 'prompt_login',
      OPENMANAGEIMAGE: 'open_manage_image',
      OPENCTXPICKER: 'open_context_picker',
      FRAMELOADING: 'frameloading'
    },
    cfg: {},
    util: {},
    initConfig:function(){
      var app = this;
      var def = new Deferred();

      fetch(this.ext.CONFIG).then(function(resp){
        if(resp.status !== 200){
          throw new Validation().addError("Configuration file not found","Reverting to default configuration. No configuration found at:"+app.ext.CONFIG,{
            code: Flybits.Validation.type.MISSINGARG
          });
        }
        return resp.json();
      }).then(function(json){
        app.cfg = App.util.Obj.extend(app.cfg,json.defaults);
        app.vm.isDebug = app.cfg.debug;
        app.cfg.defaultWindowCount = App.util.Browser.getURLParam('count')?+App.util.Browser.getURLParam('count'):null;

        def.resolve(app.cfg);
      }).catch(function(ex){
        if(ex instanceof Validation){
          def.reject(ex);
        } else{
          def.reject(new Validation().addError("Failed to read configuration file.","Reverting to default configuration. Configuration format incorrect at:"+app.ext.CONFIG,{
            code: Validation.type.MALFORMED
          }));
        }
      });

      return def.promise;
    },
    checkVersion: function(){
      fetch(this.ext.VERSION).then(function(resp){
        return resp.text();
      }).then(function(fileStr){
        console.debug(fileStr);
        App.version = fileStr;
      });
    },
    toast: function(msg, msgType, duration){
      var opt = {
        text: msg,
        gravity: 'bottom',
        duration: 3000
      };
      if(msgType === 'error'){
        opt.backgroundColor = '#b20000';
        opt.duration = 7000;
      }
      if(duration){
        opt.duration = duration;
      }

      Toastify(opt).showToast();
    },
    startup: function(){
      App.authClient = new IAMFlybits.oauth2PKCE.Client({
        spHost: App.cfg.HOST,
        projectID: App.cfg.PROJECTID,
        clientID: App.cfg.CLIENTID,
        appCallbackURL: App.cfg.APPHOST + '/dashboard' + App.cfg.res.AUTHCALLBACK
        // appCallbackURL: 'http://localhost:3200/#/auth-callback'
      });

      Flybits.init({
        HOST: App.cfg.HOST
      }).then(function(){
        deferredReady.resolve();
      });
    },
  };

  var router = App.router = new VueRouter({
    routes: [{
      path: '/',
      name: 'splash',
      component: SplashPage,
      alias: '/splash'
    },{
      path: '/landscape',
      name: 'landscape',
      component: Landscape
    },{
      path: '/configure',
      name: 'configure',
      component: Configure
    },{
      path: '/onboard',
      name: 'onboard',
      component: LinkShow
    },{
      path: '/auth-callback',
      name: 'auth-callback',
      component: AuthCallback
    },{
      path: '/journey',
      name: 'journey',
      component: Journey
    }]
  });

  App.vm = new Vue({
    router: router,
    el: '.container',
    data: function(){
      return {
        isLoaded: false,
        isLoading: false,
        isCFGLoaded: false,
        errorText: '',
        sessionUser: null
      };
    },
    computed: {
    },
    watch: {
    },
    methods: {
      refreshApp: function(){
        window.location.reload();
      }
    },
    mounted: function(){
      this.isLoaded = true;
      window.App = App;
    },
  });
  
  /**
   * Resusing the Vue event emitter interface but keeping it generic so we can
   * swap it out for our favourite event emitter if we ever need to.
   */
  App.vm.on = App.vm.$on;
  App.vm.off = App.vm.$off;
  App.vm.emit = App.vm.$emit;
  App.evt = App.vm;

  var loaderStack = [];
  var loadStart = 0;
  App.evt.on(App.actions.LOADING,function(bool, noDelay){
    if(bool){
      App.vm.isLoading = true;
      if(loaderStack.length <= 0){
        loadStart = new Date().getTime();
      }
      loaderStack.push(true);
    } else if(!bool && loaderStack.length > 1){
      loaderStack.pop();
    } else if(!bool){
      loaderStack.pop();
      var now = new Date().getTime();
      if(now - loadStart < 300 && !noDelay){
        setTimeout(function(){
          App.vm.isLoading = false;
        },300);
      } else{
        App.vm.isLoading = false;
      }
    }
  });

  return App;
})();


/*************************************/

App.checkVersion();

App.initConfig().then(function(){
  App.store = Store;
  App.startup();
}).catch(function(e){
  console.error(e);
});

var Api = (function(){
  var Api = {
    getProject: function(){
      var def = new Flybits.Deferred();
      var url = App.cfg.HOST + '/kernel/projects/' + App.cfg.PROJECTID;

      var proj;
      Flybits.util.Api.flbFetch(url).then(function(resp){
        proj = new ProjectDetails(resp.body);
        return Promise.settle([Api.getProjectLimits(),Api.getCTXPlugins()]);
      }).then(function(resp){
        var failed = resp.filter(function(result){
          return result.status === 'rejected';
        });

        if(failed.length){
          def.reject(failed[0].result);
        } else{
          if(resp[0].status === 'resolved'){
            proj.setLimitDetails(resp[0].result.body);
          }
          if(resp[1].status === 'resolved'){
            proj.setCTXPlugins(resp[1].result);
          }
  
          def.resolve(proj);
        }
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    },
    getProjectLimits: function(){
      var def = new Flybits.Deferred();
      var url = App.cfg.HOST + '/sso/apikey-management/ratelimits/' + App.cfg.PROJECTID + '?includeCatalogueUsages=true';

      Flybits.util.Api.flbFetch(url).then(function(resp){
        def.resolve(resp);
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    },
    getCTXPlugins: function(){
      var def = new Flybits.Deferred();
      var url = App.cfg.HOST + '/context/ctxschema/contextplugins?limit=1000000';

      Flybits.util.Api.flbFetch(url).then(function(resp){
        def.resolve(resp.body.map(function(obj){
          return new ContextPlugin(obj);
        }));
      }).catch(function(e){
        def.reject(e);
      });

      return def.promise;
    },
  };

  return Api;
})();
App.util.Obj = (function(){
  var s4 = function(){
    return Math.floor((1 + Math.random()) * 0x10000)
               .toString(16)
               .substring(1);
  };

  var Obj = {
    guid:function(tuples){
      var str = 'js';
      if(tuples && tuples > 0){
        for(var i = 0; i < tuples; i++){
          str += str !== 'js'?'-'+s4():s4();
        }
        return str;
      }
      return 'js' + s4() + s4() + '-' + s4() + '-' + s4() + '-' +
           s4() + '-' + s4() + s4() + s4();
    },zero2Pad: function(num){
      return ('0'+num).slice(-2);
    },
    moveItem: function(arr, from, to){
      if(!Array.isArray(arr)) {
        throw new Error('Invalid arg: must be array');
      }
    
      var item = arr.splice(from, 1);
      arr.splice(to, 0, item[0]);
    },
    removeObject:function(arr,obj,findCallback){
      var index = arr.indexOf(obj);

      if(findCallback){
        var objs = arr.filter(findCallback);
        if(objs.length > 0){
          index = arr.indexOf(objs[0]);
        }
      }

      if(index >= 0){
        return arr.splice(index,1);
      }
      return arr;
    },
    difference: function(currentSource, sourceOfTruth){
      var diff = [];

      for(var i = 0; i < currentSource.length; i++){
        if(sourceOfTruth.indexOf(currentSource[i]) < 0){
          diff.push(currentSource[i]);
        }
      }
      return diff;
    },
    intersection: function(currentSource, sourceOfTruth){
      var union = [];

      for(var i = 0; i < currentSource.length; i++){
        if(sourceOfTruth.indexOf(currentSource[i]) > -1){
          union.push(currentSource[i]);
        }
      }
      return union;
    },
    toStringParams: function(obj){
      var retObj = {};
      var keys = Object.keys(obj);
      keys.forEach(function(key){
        var val = obj[key];
        if(typeof val === 'object'){
          try{
            retObj[key] = JSON.stringify(val);
          } catch(e){
            retObj[key] = val;
          }
        } else{
          retObj[key] = val;
        }
      });
    
      return retObj;
    }
  };

  Obj.extend = (function(){
    function isMergeableObject(val) {
      var nonNullObject = val && typeof val === 'object';

      return nonNullObject && Object.prototype.toString.call(val) !== '[object RegExp]' && Object.prototype.toString.call(val) !== '[object Date]';
    }

    function emptyTarget(val) {
      return Array.isArray(val) ? [] : {};
    }

    function cloneIfNecessary(value, optionsArgument) {
      var clone = optionsArgument && optionsArgument.clone === true;
      return (clone && isMergeableObject(value)) ? deepmerge(emptyTarget(value), value, optionsArgument) : value;
    }

    function defaultArrayMerge(target, source, optionsArgument) {
      var destination = target.slice();
      source.forEach(function (e, i) {
        if (typeof destination[i] === 'undefined') {
          destination[i] = cloneIfNecessary(e, optionsArgument);
        } else if (isMergeableObject(e)) {
          destination[i] = deepmerge(target[i], e, optionsArgument);
        } else if (target.indexOf(e) === -1) {
          destination.push(cloneIfNecessary(e, optionsArgument));
        }
      });
      return destination;
    }

    function mergeObject(target, source, optionsArgument) {
      var destination = {};
      if (isMergeableObject(target)) {
        Object.keys(target).forEach(function (key) {
          destination[key] = cloneIfNecessary(target[key], optionsArgument);
        });
      }
      Object.keys(source).forEach(function (key) {
        if (!isMergeableObject(source[key]) || !target[key]) {
          destination[key] = cloneIfNecessary(source[key], optionsArgument);
        } else {
          destination[key] = deepmerge(target[key], source[key], optionsArgument);
        }
      });
      return destination;
    }

    function deepmerge(target, source, optionsArgument) {
      var array = Array.isArray(source);
      var options = optionsArgument || { arrayMerge: defaultArrayMerge };
      var arrayMerge = options.arrayMerge || defaultArrayMerge;

      if (array) {
        return Array.isArray(target) ? arrayMerge(target, source, optionsArgument) : cloneIfNecessary(source, optionsArgument);
      } else {
        return mergeObject(target, source, optionsArgument);
      }
    }

    deepmerge.all = function deepmergeAll(array, optionsArgument) {
      if (!Array.isArray(array) || array.length < 2) {
        throw new Error('first argument should be an array with at least two elements');
      }

      // we are sure there are at least 2 values, so it is safe to have no initial value
      return array.reduce(function (prev, next) {
        return deepmerge(prev, next, optionsArgument);
      });
    };

    return deepmerge;
  })();

  return Obj;
})();
App.util.Api = (function(){
  var defaultAjaxOpts = {
    method: 'GET',
    headers: {}
  };

  var Api = {
    fetch: function(url,opts){
      opts = opts || {};
      opts.respType = opts.respType || 'json';
      var def = new Deferred();
      
      var ajaxOpts = ObjUtil.extend({},defaultAjaxOpts);
      var isJSON = opts.respType === 'json';
      delete opts.respType;
      ObjUtil.extend(ajaxOpts,opts);

      fetch(url,ajaxOpts).then(this.checkResult).then(this.getResultBody)
        .then(function(respObj){
          if(isJSON){
            try{
              respObj.body = api.parseResponse(respObj.body);
              def.resolve(respObj);
            } catch(e){
              def.reject(new Validation().addError("Request Failed","Unexpected server response.",{
                code: Validation.type.MALFORMED,
              }));
            }
          } else{
            def.resolve(respObj);
          }
        }).catch(function(resp){
          api.getResultBody(resp).then(function(resultObj){
            var parsedResp = api.parseErrorMsg(resultObj.body);
            def.reject(new Validation().addError('Request error',parsedResp,{
              serverCode: resp.status
            }));
          });
        });

      return def.promise;
    },
    checkResult: function(resp){
      if(resp.status >= 200 && resp.status < 300){
        return resp;
      }
      throw resp;
    },
    getResultBody: function(resp){
      var def = new Deferred();
      if(resp && resp.text){
        var respHeaders = {};
        resp.headers.forEach(function(val,key){
          respHeaders[key] = val;
        });
        resp.text().then(function(str){
          def.resolve({
            body: str,
            headers: respHeaders
          });
        }).catch(function(e){
          def.reject(e);
        });
      } else{
        def.resolve({
          body: "",
          headers: {}
        });
      }

      return def.promise;
    },
    getResultJSON: function(resp){
      return resp.json();
    },
    htmlEncode:function(value){
      /*global encodeURIComponent*/
      return encodeURIComponent(value);
    },
    htmlDecode:function(str){
      return str.replace(/&#?(\w+);/g, function(match, dec) {
        if(isNaN(dec)) {
          chars = {quot: 34, amp: 38, lt: 60, gt: 62, nbsp: 160, copy: 169, reg: 174, deg: 176, frasl: 47, trade: 8482, euro: 8364, Agrave: 192, Aacute: 193, Acirc: 194, Atilde: 195, Auml: 196, Aring: 197, AElig: 198, Ccedil: 199, Egrave: 200, Eacute: 201, Ecirc: 202, Euml: 203, Igrave: 204, Iacute: 205, Icirc: 206, Iuml: 207, ETH: 208, Ntilde: 209, Ograve: 210, Oacute: 211, Ocirc: 212, Otilde: 213, Ouml: 214, times: 215, Oslash: 216, Ugrave: 217, Uacute: 218, Ucirc: 219, Uuml: 220, Yacute: 221, THORN: 222, szlig: 223, agrave: 224, aacute: 225, acirc: 226, atilde: 227, auml: 228, aring: 229, aelig: 230, ccedil: 231, egrave: 232, eacute: 233, ecirc: 234, euml: 235, igrave: 236, iacute: 237, icirc: 238, iuml: 239, eth: 240, ntilde: 241, ograve: 242, oacute: 243, ocirc: 244, otilde: 245, ouml: 246, divide: 247, oslash: 248, ugrave: 249, uacute: 250, ucirc: 251, uuml: 252, yacute: 253, thorn: 254, yuml: 255, lsquo: 8216, rsquo: 8217, sbquo: 8218, ldquo: 8220, rdquo: 8221, bdquo: 8222, dagger: 8224, Dagger: 8225, permil: 8240, lsaquo: 8249, rsaquo: 8250, spades: 9824, clubs: 9827, hearts: 9829, diams: 9830, oline: 8254, larr: 8592, uarr: 8593, rarr: 8594, darr: 8595, hellip: 133, ndash: 150, mdash: 151, iexcl: 161, cent: 162, pound: 163, curren: 164, yen: 165, brvbar: 166, brkbar: 166, sect: 167, uml: 168, die: 168, ordf: 170, laquo: 171, not: 172, shy: 173, macr: 175, hibar: 175, plusmn: 177, sup2: 178, sup3: 179, acute: 180, micro: 181, para: 182, middot: 183, cedil: 184, sup1: 185, ordm: 186, raquo: 187, frac14: 188, frac12: 189, frac34: 190, iquest: 191, Alpha: 913, alpha: 945, Beta: 914, beta: 946, Gamma: 915, gamma: 947, Delta: 916, delta: 948, Epsilon: 917, epsilon: 949, Zeta: 918, zeta: 950, Eta: 919, eta: 951, Theta: 920, theta: 952, Iota: 921, iota: 953, Kappa: 922, kappa: 954, Lambda: 923, lambda: 955, Mu: 924, mu: 956, Nu: 925, nu: 957, Xi: 926, xi: 958, Omicron: 927, omicron: 959, Pi: 928, pi: 960, Rho: 929, rho: 961, Sigma: 931, sigma: 963, Tau: 932, tau: 964, Upsilon: 933, upsilon: 965, Phi: 934, phi: 966, Chi: 935, chi: 967, Psi: 936, psi: 968, Omega: 937, omega: 969}
          if (chars[dec] !== undefined){
            dec = chars[dec];
          }
        }
        return String.fromCharCode(dec);
      });
    },
    base64Decode: function(str){
      return decodeURIComponent(Array.prototype.map.call(atob(str), function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
    },
    parseResponse: function(rawResponse){
      return JSON.parse(rawResponse,function(key,val){
        if(typeof val === "string"){
          return api.htmlDecode(val);
        }
        return val;
      });
    },
    parseErrorMsg: function(rawResponse){
      try{
        var resp = this.parseResponse(rawResponse);
      } catch(e){
        return "Malformed server response";
      }
      var msg = null;

      if(resp){
        if(resp.error){
          resp = resp.error;
        }
        
        return resp.messageJSON || resp.exceptionMessage || resp.message || "Unexpected error has occurred";
      }

      return msg;
    }
  };

  return Api;
})();
Date.prototype.monthNames = [
  "January", "February", "March",
  "April", "May", "June",
  "July", "August", "September",
  "October", "November", "December"
];
Date.prototype.dayNames = [
  "Sunday", "Monday", "Tuesday",
  "Wednesday", "Thursday", "Friday", "Saturday"
];
Date.prototype.getMonthName = function() {
  return this.monthNames[this.getMonth()];
};
Date.prototype.getShortMonthName = function () {
  return this.getMonthName().substr(0, 3);
};
Date.prototype.getDayName = function(){
  return this.dayNames[this.getDay()];
};
Date.prototype.getShortDayName = function(){
  return this.getDayName().substr(0,3);
};

App.util.Browser = (function(){
  return {
    getCookie: function(key) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + key + "=");
      if (parts.length == 2) {
        return parts.pop().split(";").shift();
      } else{
        return null;
      }
    },
    setCookie: function(key,value,expiryDateObj){
      var expires = "";
      if (expiryDateObj) {
        expires = "; expires=" + expiryDateObj.toGMTString();
      }
      document.cookie = key + "=" + value + expires + "; path=/";
    },
    getURLParam:function(name, uri) {
      uri = uri || window.location.href;
      name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
      var regexS = "[\\?&]" + name + "=([^&#]*)";
      var regex = new RegExp(regexS);
      var results = regex.exec(uri);
      if (results === null)
        return "";
      else
        return results[1];
    },
  };
})();
App.util.Content = (function(){
  
  var Content = {
    flattenLocales: function(obj){
      var view = this;
      var keys = Object.keys(obj);
      keys.forEach(function(key){
        if(key === 'localizations'){
          var localeObj = obj.localizations && obj.localizations.en?obj.localizations.en:null;
          if(localeObj){
            Object.assign(obj, localeObj);
          }
        } else if(typeof obj[key] === 'object' && !Array.isArray(obj[key])){
          Content.flattenLocales(obj[key]);
        } else if(Array.isArray(obj[key]) && typeof obj[key][0] === 'object'){
          obj[key].forEach(function(o){
            Content.flattenLocales(o);
          });
        }
      });
    },
    /**
     * @todo account for object arrays and how many objects exist in the data cause this only goes through the schema
     * @todo account for primitive arrays
     * @param {Flybits.ContentTemplate} template 
     * @returns 
     */
    getSchemaFieldList: function(template){
      var list = [];
      var recursiveAssembly = function(fields, parentKey, parentName, parentType){
        fields.forEach(function(field, index){
          var curKey = field.key;
          // no need to account for localizations because the c5 wrapper will flatten locales based on device locale and not pass them to the renderer.
          if(parentKey){
            curKey = parentType && parentType === 'array'?parentKey+'['+index+']':parentKey;
            curKey = curKey + '.' + field.key
          }

          if(field.type === 'object'){
            recursiveAssembly(field.fields, curKey, field.displayName, field.type);
          } else{
            curKey = 'data.'+ curKey;
            var name = parentName?parentName+' > '+field.displayName:field.displayName;
            list.push({
              key: curKey,
              name: name,
              type: field.type,
              uiType: field.uiType
            });
          }
        });
      };
      recursiveAssembly(template.schema);
      return list.sort(function(fieldA, fieldB){
        const nameA = fieldA.name.toUpperCase();
        const nameB = fieldB.name.toUpperCase();
        if(nameA < nameB){
          return -1;
        }
        if(nameA > nameB){
          return 1;
        }

        return 0;
      });
    }
  };

  return Content;
})();
})(window, document);